<!--  -->
<template>
  <div class="regBody" id="body" v-loading="isLoad">
    <div
      style="height: 2rem;line-height: 2rem;font-size: 1.2rem;position: sticky;top: 3rem;background-color: #fff;z-index: 999;">
      预览文书开关：<el-switch v-model="wenshuSwtich" @change="switchOpen"></el-switch>
      <span v-permission:function="['preview_material_switch']" style="margin-left: 10px">预览原材料开关：<el-switch
          v-model="yuanCaiLiaoSwtich" @change="yuanCaiLiaoSwtichOpen"></el-switch></span>
      <span v-permission:function="['preview_material_switch']" style="margin-left: 10px">跳转开关：<el-switch
          v-model="flipSwitch"></el-switch></span>
    </div>

    <div style="display: flex; justify-content: center">
      <!-- <div style="position: relative;width:48%" >
        <iframe width="100%" height="600px"
          src="https://view.officeapps.live.com/op/view.aspx?src=nacos.szplcy.com/aaa.docx"></iframe>
      </div> -->
      <div v-if="docWidth == '50%'" style="position: relative" :style="{ width: docWidth }">
        <div class="left" @click="switchLast()">
          <img class="lr" style="width: 60px; height: 30px" :src="`${$baseUrl}image/arrow/left.png`" />
        </div>
        <div class="right" @click="switchNext()">
          <img class="ar" style="width: 60px; height: 30px" :src="`${$baseUrl}image/arrow/right.png`" />
        </div>
        <div style="overflow: scroll;position: fixed;height: 80%" class="docxRefPar">
          <el-backtop target=".docxRefPar" :bottom="100">
            <div style="
                  height: 100%;
                  width: 100%;
                  background-color: #f2f5f6;
                  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
                  text-align: center;
                  line-height: 40px;
                  color: #1989fa;
              ">
              ↑
            </div>
          </el-backtop>
          <div v-if="showDoc && wenshuSwtich" class="docxRef" style="width: 100%; "></div>
          <pdfpreview style="width: 100%;" v-if="showDoc && yuanCaiLiaoSwtich" :pageTotalNum="pageTotalNum"
            :pageNum="pageNum" :fileName="fileName" :pdfUrl="pdfUrl" :fileOcrDetails="fileOcrDetails"
            :textType="textType" @updatePageNum="updatePageNum"></pdfpreview>
        </div>
      </div>
      <div id="formClass" class="formClass" :style="{ width: formWidth }">
        <el-collapse v-model="openData">
          <!--案件基本信息-->
          <el-collapse-item name="1" size="mini" class="title">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-info"></i>案件基本信息
                <a name="baseInfo" id="baseInfoId" style="height: 0px"></a>
              </div>
            </template>
            <div class="form-content">
              <el-form :inline="true" :model="caseInfo" ref="baseForm" :rules="baseRules" label-width="100px"
                class="demo-ruleForm">
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="registerCode" label="案号：">
                      <el-input v-model="caseInfo.registerCode" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="batchId" label="批次号：">
                      <el-input v-model="caseInfo.batchId" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="案由：">
                      <el-input v-model="caseInfo.cause" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="courtName" label="法院名称：">
                      <el-select clearable style="width: 100%" v-model="caseInfo.courtName" placeholder="请选择法院">
                        <el-option v-for="item in courtName" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="标的：">
                      <el-input type="number" v-model="caseInfo.underlyingAmount" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="案件状态：" prop="caseStatus">
                      <el-select @change="switchStatus" clearable v-model="caseInfo.caseStatus" placeholder="请选择"
                        style="width: 100%">
                        <el-option label="未处置" value="未处置"></el-option>
                        <el-option label="处置中" value="处置中"></el-option>
                        <el-option label="提交诉讼服务网" value="提交诉讼服务网"></el-option>
                        <el-option label="提交法院" value="提交法院"></el-option>

                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="委托时间：">
                      <el-date-picker style="width: 100%;" v-model="caseInfo.entrustmentDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="提交法院日期：" prop="courtSubDate">
                      <el-date-picker style="width: 100%" v-model="caseInfo.courtSubDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="律师费：">
                      <el-input type="number" v-model="caseInfo.lawyerFee" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="是否还清：">
                      <el-radio-group v-model="caseInfo.isRepayment" style="width: 100%">
                        <el-radio label="是"></el-radio>
                        <el-radio label="否"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="案件受理费：">
                      <el-input type="number" v-model="caseInfo.caseFilingFee" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="财产保全费：">
                      <el-input type="number" v-model="caseInfo.propertyPreservationFee" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="公告费：">
                      <el-input type="number" v-model="caseInfo.announcementFee" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="第一次催收日期：" prop="firstCollectionDate">
                      <el-date-picker style="width: 100%" v-model="caseInfo.firstCollectionDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="最后一次催收日期：" prop="lastCollectionDate">
                      <el-date-picker style="width: 100%" v-model="caseInfo.lastCollectionDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="约定管辖：">
                      <el-select clearable filterable style="width: 100%" v-model="caseInfo.agreedJurisdiction"
                        placeholder="请选择协议名称">
                        <el-option v-for="(item, index) in agreedJurisdiction" :key="index" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div style="width: 200px; margin: 0 auto">
                  <el-button type="primary" @click="submitBaseForm('baseForm')">保存案件基本信息</el-button>
                </div>
              </el-form>
            </div>
          </el-collapse-item>
          <!--当事人信息-->
          <el-collapse-item name="2" class="title">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-check"></i>
                当事人信息
                <el-button type="success" size="mini" plain round style="margin: 10px 0"
                  @click.stop="addPlaintiff(caseInfo.id)">+添加原告</el-button>
                <el-button type="success" size="mini" plain round style="margin: 10px 0"
                  @click.stop="addDefendant(caseInfo.id)">
                  +添加被告</el-button>
                <a name="pla" id="plaId"></a>
                <a name="def" id="defId"></a>
              </div>
            </template>
            <div style="" class="form-content">
              <el-collapse v-model="plaNames">
                <div v-for="(item, index) in plaList" :key="index + 'party1'" class="ygClass">
                  <!--'原告'" -->
                  <el-collapse-item :name="item.id">
                    <template slot="title">
                      <div class="itemName">(原告){{ item.name }}
                        <el-select @change="changeYg(yg.value, index, yg.label)" clearable v-model="yg"
                          placeholder="请选择" style="width: 100%; margin-left: 10px;">
                          <el-option v-for="item in plaintiffName" :key="item.value" :label="item.label" :value="item">
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <el-form :inline="true" :model="item" :rules="plaRules" ref="plaForm" label-width="100px"
                      class="demo-ruleForm">
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="当事人类型：" prop="partiesType">
                            <el-radio-group v-model="item.partiesType" style="width: 100%">
                              <el-radio label="自然人"></el-radio>
                              <el-radio label="企业"></el-radio>
                            </el-radio-group> </el-form-item></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="litigationStatus" label="诉讼地位：">
                            <el-radio-group v-model="item.litigationStatus" style="width: 100%">
                              <el-radio label="原告"></el-radio>
                              <el-radio label="被告"></el-radio>
                            </el-radio-group> </el-form-item></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="公司：" prop="name">
                            <el-input v-model="item.name" style="width: 100%"></el-input> </el-form-item></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="idCard" label="社会统一信用代码：">
                            <el-input v-model="item.idCard" style="width: 100%"></el-input> </el-form-item></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="法定代表人：" prop="legalRepresentative">
                            <el-input v-model="item.legalRepresentative" style="width: 100%"></el-input>
                          </el-form-item></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="负责人身份证：" prop="legalRepresentativeIdCard">
                            <el-input v-model="item.legalRepresentativeIdCard" style="width: 100%"></el-input>
                            <div class="ygIdCard" style="
                                font-size: 12px;
                                height: 10px;
                                color: #f56c6c;
                                display: none;
                                margin-left: 20px;
                              ">
                              身份证不符合
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="职务：" prop="post">
                            <el-input v-model="item.post" style="width: 100%"></el-input> </el-form-item></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="手机号码：" prop="phone">
                            <el-input type="tel" v-model="item.phone" style="width: 100%"></el-input>
                            <div class="ygPhone" style="
                                font-size: 12px;
                                height: 10px;
                                color: #f56c6c;
                                display: none;
                                margin-left: 20px;
                              ">
                              手机号不符合
                            </div>
                          </el-form-item></el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="24" style="height: 60px">
                          <el-form-item label="公司住所地：" prop="address">
                            <el-input v-model="item.address" style="width: 100%"></el-input> </el-form-item></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24" style="height: 60px">
                          <el-form-item label="送达地址：" prop="serviceAddress">
                            <el-input v-model="item.serviceAddress" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24" style="height: 60px">
                          <el-form-item label="邮箱：">
                            <el-input type="email" v-model="item.email" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <div style="width: 20rem; margin: 0 auto">
                        <el-button v-if="item.id <= 0" type="primary"
                          @click="saveOfUpdatePartyInfo(item, 'plaForm', index)">新增原告信息</el-button>
                        <el-button type="primary" v-else
                          @click="saveOfUpdatePartyInfo(item, 'plaForm', index)">更新原告信息</el-button>
                        <el-button type="danger" @click="deletePlaPartyInfo(index)">删除原告</el-button>
                      </div>
                    </el-form>
                    <!-- </div> -->
                  </el-collapse-item>
                </div>
              </el-collapse>
              <!--'被告'" -->
              <el-collapse>
                <div v-for="(item, index) in defList" :key="index + 'party2'" class='ygClass'>
                  <el-collapse-item style="" :name="item.id">
                    <template slot="title">
                      <div class="itemName">(被告){{ item.name }}</div>
                    </template>

                    <div>
                      <el-form :inline="true" :model="item" ref="defForm" :rules="defRules" label-width="100px"
                        class="demo-ruleForm">
                        <el-row>
                          <div style="display:flex;justify-content:center">
                            <el-upload :action="getIdCardUploadUrl(index)" multiple :http-request="ocrUploadFile"
                              :on-change="ocrFileChange" :file-list="idCardFileList">
                              <el-button size="small" type="primary">识别身份证信息</el-button>
                            </el-upload>
                          </div>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="当事人类型：" prop="partiesType">
                              <el-radio-group v-model="item.partiesType" style="width: 100%">
                                <el-radio label="自然人"></el-radio>
                                <el-radio label="企业"></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="诉讼地位：" prop="litigationStatus">
                              <el-radio-group v-model="item.litigationStatus" style="width: 100%">
                                <el-radio label="原告"></el-radio>
                                <el-radio label="被告"></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="名字：" prop="name">
                              <el-input v-model="item.name" style="width: 100%" @focus="changeIdCard(index)"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item prop="idCard" label="公民身份号码：">
                              <el-input @input="getBirthdayAndSex(item.idCard, index)" v-model="item.idCard"
                                @focus="changeIdCard(index)" style="width: 100%"></el-input>
                              <div class="bgIdCard" style="
                                  font-size: 12px;
                                  height: 10px;
                                  color: #f56c6c;
                                  display: none;
                                  margin-left: 20px;
                                ">
                                身份证不符合
                              </div>
                            </el-form-item></el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="性别：" prop="sex">
                              <el-radio-group v-model="item.sex" style="width: 100%">
                                <el-radio label="男"></el-radio>
                                <el-radio label="女"></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="出生日期：" prop="birthday">
                              <el-date-picker placeholder="选择时间" type="date" v-model="item.birthday" style="width: 100%"
                                @focus="changeIdCard(index)" value-format="yyyy-MM-dd"
                                format="yyyyMMdd"></el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="民族：" prop="nation">
                              <el-input v-model="item.nation" style="width: 100%" @focus="changeIdCard(index)">
                                <template slot="append">族</template>
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="手机号码：" prop="phone">
                              <el-input type="tel" v-model="item.phone" style="width: 100%"
                                @focus="changeDocName('申请表', true)"></el-input>
                              <div class="bgPhone" style="
                                  font-size: 12px;
                                  height: 10px;
                                  color: #f56c6c;
                                  display: none;
                                  margin-left: 20px;
                                ">
                                手机号不符合
                              </div>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="工作单位：" prop="workUnit">
                              <el-input v-model="item.workUnit" style="width: 100%"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="职务：" prop="post">
                              <el-input v-model="item.post" style="width: 100%"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row>
                          <el-col :span="24" style="height: 60px">
                            <el-form-item prop="address" label="户籍地址：">
                              <el-input v-model="item.address" style="width: 100%" @focus="changeIdCard(index)"
                                @input="inputAddress(item, index)"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24" style="height: 60px">
                            <el-form-item label="送达地址：" prop="serviceAddress">
                              <el-input v-model="item.serviceAddress" style="width: 100%"
                                @focus="changeDocName('送达地址', true)"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24" style="height: 60px">
                            <el-form-item label="约定送达地址：">
                              <el-input v-model="item.agreedDeliveryAddress" style="width: 100%"
                                @focus="changeDocName('地址确认书', true)"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="邮箱/客户号：">
                              <el-input type="email" v-model="item.email" style="width: 100%"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="还款责任：" prop="responsibility">
                              <el-select clearable style="width: 100%" v-model="item.responsibility" placeholder="请选择">
                                <el-option v-for="item in responsibility" :key="item" :label="item" :value="item">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="被告关系：" prop="defRelationship">
                              <el-select clearable style="width: 100%" v-model="item.defRelationship" placeholder="请选择"
                                @focus="changeDocName('结婚证', true)">
                                <el-option v-for="item in defRelationship" :key="item" :label="item" :value="item">
                                </el-option>
                              </el-select> </el-form-item></el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="担保合同名称：">
                              <el-input v-model="item.guaranteeContract" style="width: 100%"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="spanWidth" style="height: 60px">
                            <el-form-item label="合同签订日期：" prop="signingDate">
                              <el-date-picker placeholder="选择时间" type="date" v-model="item.signingDate"
                                style="width: 100%" value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <div></div>
                        <div style="width: 20rem; margin: 0 auto">
                          <el-button v-if="item.id <= 0" type="primary"
                            @click="saveOfUpdatePartyInfo(item, 'defForm', index)">新增被告信息</el-button>
                          <el-button v-else type="primary"
                            @click="saveOfUpdatePartyInfo(item, 'defForm', index)">更新被告信息</el-button>
                          <el-button @click="deleteDefPartyInfo(index)" type="danger">删除被告</el-button>
                        </div>
                      </el-form>
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>
          </el-collapse-item>
          <!--代理人信息-->
          <el-collapse-item name="3">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-custom"></i>
                代理人信息
                <el-button plain round type="success" size="mini" style="margin: 10px 0" @click.stop="addPlaAgent()">
                  +添加原告代理人
                </el-button>
                <a name="plaAgent" id="plaAgentId"></a>
              </div>
            </template>
            <div style="" class="form-content">

              <el-collapse v-model="plaAgentNames" v-for="(item, index) in plaAgentList" :key="index + 'agent1'">
                <el-collapse-item v-if="item.agentPosition == '原告'" style="" class="yg" :name="item.id">
                  <template slot="title">
                    <div class="itemName">(原告代理人){{ item.agentName }}</div>
                  </template>

                  <div style="margin-top: 10px">
                    <el-form :inline="true" :model="item" :rules="defAgentRules" ref="plaAgentForm" label-width="100px"
                      class="demo-ruleForm">
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="第一代理人类型：" prop="agentType">
                            <el-select clearable style="width: 100%" v-model="item.agentType" placeholder="请选择代理人类型">
                              <el-option label="执业律师" value="执业律师"></el-option>
                              <el-option label="基层法律服务工作者" value="基层法律服务工作者"></el-option>
                              <el-option label="当事人的近亲属或工作人员" value="当事人的近亲属或工作人员"></el-option>
                              <el-option label="当事人所在社区、单位以及有关社会群体推荐人员" value="当事人所在社区、单位以及有关社会群体推荐人员"></el-option>
                              <el-option label="经赔偿委员会许可的其他公民" value="经赔偿委员会许可的其他公民"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="诉讼代理人名：" prop="agentName">
                            <el-input v-model="item.agentName" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="身份证号：" prop="idCard">

                            <el-input v-model="item.idCard" style="width: 100%"></el-input>
                            <div class="agentTip" style="
                                font-size: 12px;
                                height: 10px;
                                color: #f56c6c;
                                display: none;
                                margin-left: 20px;
                              ">
                              身份证不符合
                            </div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="手机号：" prop="phone">

                            <el-input type="tel" v-model="item.phone" style="width: 100%"></el-input>
                            <div class="agentPhone" style="
                                font-size: 12px;
                                height: 10px;
                                color: #f56c6c;
                                display: none;
                                margin-left: 20px;
                              ">
                              手机号不符合
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="地址：">
                            <el-input v-model="item.address" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="律师执业证：" prop="lawyerLicenseNo">
                            <el-input v-model="item.lawyerLicenseNo" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="性别：" prop="sex">
                            <el-radio-group v-model="item.sex" style="width: 100%">
                              <el-radio label="男"></el-radio>
                              <el-radio label="女"> </el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="庭审是否到场：">
                            <el-radio-group v-model="item.isPresent" style="width: 100%">
                              <el-radio label="是"></el-radio>
                              <el-radio label="否"> </el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="lawfirmName" label="律所名称：">
                            <el-input v-model="item.lawfirmName" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="wechat" label="微信号：">
                            <el-input v-model="item.wechat" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="email" label="邮箱：">
                            <el-input v-model="item.email" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <div></div>
                      <div style="width: 400px; margin: 0 auto">
                        <el-button v-if="item.id <= 0" type="primary"
                          @click="addAgentInfo(item, 'plaAgentForm', index)">新增原告代理人信息</el-button>
                        <el-button type="primary" v-else
                          @click="updateAgentInfo(item, 'plaAgentForm', index)">更新原告代理人信息</el-button>
                        <el-button type="danger" @click="deleteAgent(index, 1)">删除原告代理人</el-button>
                      </div>
                    </el-form>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-collapse-item>
          <!--信用卡信息-->
          <el-collapse-item name="4" v-show="this.caseInfo.cause == '信用卡纠纷'">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-finance"></i>

                信用卡信息
                <el-button type="success" size="mini" plain round style="margin: 10px 0" @click.stop="addCard()">
                  +添加信用卡信息
                </el-button>
                <a name="cardInfo" id="cardInfoId"></a>
              </div>
            </template>
            <div class="form-content">

              <el-collapse v-model="cardNames" v-for="(item, index) in caseInfo.cardInfoList" :key="item.id" style="">
                <el-collapse-item :name="item.id">
                  <template slot="title">
                    <div class="itemName" style="display: flex">
                      <el-upload :action="getOcrloadUrl()" multiple :http-request="HttpUploadFileByCard"
                        :on-change="fileChange" :file-list="fileList">
                        <el-button size="small" @click="getIndex(index)" type="primary">识别信用卡信息</el-button>
                      </el-upload>
                      卡号: {{ item.cardNumber }}
                    </div>
                  </template>

                  <div style="margin-top: 10px">
                    <el-form :inline="true" :rules="cardRules" :model="item" label-width="100px" ref="cardForm"
                      class="demo-ruleForm">
                      <el-row>
                        <el-col :span="24" style="height: 60px"><el-divider>基本信息</el-divider></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="applyTitle" label="申请表类型：">
                            <el-select clearable filterable style="width: 100%" v-model="item.applyTitle"
                              @focus="changeDocName('申请表类型', false)" placeholder="请选择类型">
                              <el-option v-for="(item, index) in applicationType" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="signingName" label="签署协议名称：">
                            <el-select clearable filterable style="width: 100%" v-model="item.signingName"
                              @focus="changeDocName('签署协议名称', false)" placeholder="请选择协议名称">
                              <el-option v-for="(item, index) in areementList" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="applicationDate" label="申请日期：">
                            <el-date-picker placeholder="选择时间" v-model="item.applicationDate" style="width: 100%"
                              @focus="changeDocName('申请日期', true)" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="信用卡号：" prop="cardNumber">
                            <el-input v-model="item.cardNumber" style="width: 100%"
                              @focus="changeDocName('信用卡号', true)"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="产品名称：">
                            <el-select filterable clearable style="width: 100%" v-model="item.productName"
                              @focus="changeDocName('产品名称', true)" placeholder="请选择产品名称">
                              <el-option v-for="(item, index) in productNameList" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="开户日期：">
                            <el-date-picker placeholder="选择时间" v-model="item.openingDate" style="width: 100%"
                              @focus="changeDocName('开户日期', true)" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="分期账号：">
                            <el-input v-model="item.accountNumber" style="width: 100%"
                              @focus="changeDocName('账号', true)"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="受理机构：" prop="acceptingAuthority">
                            <el-input v-model="item.acceptingAuthority" style="width: 100%"
                              @focus="changeDocName('账号', true)"></el-input>
                          </el-form-item>
                        </el-col>


                        <el-col :span="24" style="height: 60px"><el-divider>金额信息</el-divider></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="本金：" prop="principal">
                            <el-input @input="replaceMoney($event, 'principal', index)" maxlength="9"
                              @focus="changeDocName('本金', true)" v-model="item.principal"
                              style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="利息：">
                            <el-input @input="replaceMoney($event, 'interest', index)" maxlength="9"
                              @focus="changeDocName('利息', true)" v-model="item.interest" style="width: 100%"
                              prop="interest"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="分期手续费：" prop="serviceCharge">
                            <el-input @input="replaceMoney($event, 'serviceCharge', index)" maxlength="9"
                              @focus="changeDocName('分期手续费', true)" v-model="item.serviceCharge"
                              style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="违约金：">
                            <el-input @input="replaceMoney($event, 'liquidatedDamages', index)" maxlength="9"
                              @focus="changeDocName('违约金', true)" v-model="item.liquidatedDamages"
                              style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="分期通手续费：">
                            <el-input @input="replaceMoney($event, 'serviceChargeTwo', index)" maxlength="9"
                              @focus="changeDocName('分期通手续费', true)" v-model="item.serviceChargeTwo"
                              style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="透支额度：">
                            <el-input @input="replaceMoney($event, 'overdraftLimit', index)" maxlength="9"
                              v-model="item.overdraftLimit" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="其他费用：">
                            <el-input @input="replaceMoney($event, 'otherExpenses', index)" maxlength="9"
                              v-model="item.otherExpenses" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="其他费用说明：">
                            <el-input v-model="item.otherDescription" style="width: 100%">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="其他费用2：">
                            <el-input @input="replaceMoney($event, 'otherExpenses2', index)" maxlength="9"
                              v-model="item.otherExpenses2" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="其他费用2说明：">
                            <el-input v-model="item.otherDescription2" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="合计金额：">
                            {{ towNumber2(item.totalDebt, item.hexiaoInterest, item.interest) }}
                          </el-form-item>
                        </el-col>

                        <el-col :span="24" style="height: 60px"><el-divider>核销信息</el-divider></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="核销日期：" prop="accountDestroyDate">
                            <el-date-picker @change="accountDateChange" placeholder="选择时间"
                              @focus="changeDocName('核销日期', false)" v-model="item.accountDestroyDate"
                              style="width: 100%" value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="accountDestroyEndDate" label="核销截止日期：" value-format="yyyy-MM-dd"
                            format="yyyyMMdd">
                            <el-date-picker @change="accountDateChange" placeholder="选择时间"
                              @focus="changeDocName('核销截止日期', false)" v-model="item.accountDestroyEndDate"
                              style="width: 100%" value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="核销利息：">
                            {{ towNumber(item.hexiaoInterest - item.interest) }}
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px"></el-col>


                        <el-col :span="24" style="height: 60px"><el-divider>日期信息</el-divider></el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="逾期日期：" prop="overdueDate">
                            <el-date-picker placeholder="选择时间" v-model="item.overdueDate" style="width: 100%"
                              @focus="changeDocName('逾期日期')" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="本金截止日期：" prop="principalDate">
                            <el-date-picker placeholder="选择时间" v-model="item.principalDate"
                              @focus="changeDocName('交易明细', true)" style="width: 100%" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="利息截止日期：" prop="deadlineDate">
                            <el-date-picker placeholder="选择时间" v-model="item.deadlineDate" style="width: 100%"
                              @focus="changeDocName('利息截止日期', true)" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="serviceChargeEndDate" label="分期手续费截止日期：">
                            <el-date-picker style="width: 100%" placeholder="选择时间" v-model="item.serviceChargeEndDate"
                              @focus="changeDocName('分期手续费截止日期', true)" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="违约金截止日期：" prop="liqDamagesEndDate">
                            <el-date-picker style="width: 100%" placeholder="选择时间" v-model="item.liqDamagesEndDate"
                              @focus="changeDocName('违约金截止日期', true)" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="分期通截止日期：">
                            <el-input v-model="item.serviceChargeTwoEndDate" style="width: 100%"
                              @focus="changeDocName('交易明细', true)"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="其他费用截止日期：">
                            <el-date-picker placeholder="选择时间" v-model="item.otherDescriptionEndDate"
                              @focus="changeDocName('交易明细', true)" style="width: 100%" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="其他费用2截止日期：">
                            <el-date-picker placeholder="选择时间" v-model="item.otherDescription2EndDate"
                              @focus="changeDocName('交易明细', true)" style="width: 100%" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="流水截止日：" prop="cutOffDate">
                            <el-date-picker placeholder="选择时间" v-model="item.cutOffDate"
                              @focus="changeDocName('交易明细', true)" style="width: 100%" value-format="yyyy-MM-dd"
                              format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="欠款总额：">
                            <el-input @input="replaceMoney($event, 'totalDebt', index)" :disabled="true" maxlength="9"
                              v-model="item.totalDebt" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="24" style="height: 60px"><el-divider>条约信息</el-divider></el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="interestClause" label="利息条约：">
                            <el-select clearable filterable style="width: 100%" v-model="item.interestClause"
                              placeholder="请选择协议名称">
                              <el-option v-for="(item, index) in lxclauses" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="liquidatedDamagesClause" label="违约金条约：">
                            <el-select clearable filterable style="width: 100%" v-model="item.liquidatedDamagesClause"
                              placeholder="请选择协议名称">
                              <el-option v-for="(item, index) in wyjclauses" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="serviceFeeClause" label="手续费条款：">
                            <el-select clearable filterable style="width: 100%" v-model="item.serviceFeeClause"
                              placeholder="请选择协议名称">
                              <el-option v-for="(item, index) in sxfclauses" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="breachLiability" label="违约责任条款：">
                            <el-select clearable filterable style="width: 100%" v-model="item.breachLiability"
                              placeholder="请选择协议名称">
                              <el-option v-for="(item, index) in breachLiability" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="terminationConditions" label="解除条件：">
                            <el-select clearable filterable style="width: 100%" v-model="item.terminationConditions"
                              placeholder="请选择协议名称">
                              <el-option v-for="(item, index) in terminationConditions" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                      </el-row>
                      <div style="width: 20rem; margin: 0 auto">
                        <el-button type="primary" v-if="item.id <= 0 || item.id == ''"
                          @click="addCaseCardInfo(item, 'cardForm', index)">新增信用卡信息</el-button>
                        <el-button type="primary" v-else
                          @click="updateCaseCardInfo(item, 'cardForm', index)">更新信用卡信息</el-button>
                        <el-button type="danger" @click="deleteCard(index)">删除信用卡</el-button>
                      </div>
                    </el-form>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-collapse-item>
          <!-- 抵押-->
          <el-collapse-item name="5" class="title">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-shop"></i>
                抵押物信息
                <el-button size="mini" type="success" plain round style="margin: 10px 0"
                  @click.stop="addEvidence(caseInfo.id)">
                  +添加抵押物
                </el-button>
                <a name="diyawu" id="diyawuId"></a>
              </div>
            </template>


            <el-collapse v-model="eviNames" v-for="(item, index) in caseInfo.czEvidence" :key="item.id" style="">
              <el-collapse-item :name="item.id">
                <template slot="title">
                  <div class="itemName">
                    {{ item.evidenceName }}
                  </div>
                </template>

                <div style="margin-top: 10px">
                  <el-form :rules="eviRules" :inline="true" :model="item" ref="eviForm" label-width="100px"
                    class="demo-ruleForm">
                    <el-row>
                      <el-col :span="spanWidth" style="height: 60px">
                        <el-form-item label="类型（抵押\线索）" prop="type">
                          <el-select clearable v-model="item.type" placeholder="请选择"
                            style="width: 100%">
                            <el-option label="抵押" value="抵押"></el-option>
                            <el-option label="财产线索" value="财产线索"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="spanWidth" style="height: 60px">
                        <el-form-item label="抵押物名称：" prop="evidenceName">
                          <el-input v-model="item.evidenceName" placeholder="XX牌小型汽车" style="width: 100%"
                            @focus="changeDocName('机动车登记证书,机动车行驶证', false)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="spanWidth" style="height: 60px">
                        <el-form-item label="抵押物类型：" prop="evidenceType">
                          <el-input v-model="item.evidenceType" placeholder="汽车/房产" style="width: 100%"
                            @focus="changeDocName('机动车登记证书,机动车行驶证', false)"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="spanWidth" style="height: 60px">
                        <el-form-item label="抵押物编号：" prop="evidenceNum">
                          <el-input v-model="item.evidenceNum" placeholder="粤KXXXXX" style="width: 100%"
                            @focus="changeDocName('机动车登记证书,机动车行驶证', false)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="spanWidth" style="height: 60px">
                        <el-form-item label="车辆识别代号/车架号：">
                          <el-input v-model="item.vin" placeholder="粤KXXXXX" style="width: 100%"
                            @focus="changeDocName('机动车登记证书,机动车行驶证', false)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="spanWidth" style="height: 60px">
                        <el-form-item required prop="registrationDate" label="抵押物登记时间：">
                          <el-date-picker style="width: 100%" v-model="item.registrationDate" type="date"
                            @focus="changeDocName('机动车登记证书', true)" value-format="yyyy-MM-dd" format="yyyyMMdd"
                            placeholder="选择日期时间">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <div style="width: 20rem; margin: 0 auto">
                      <el-button v-if="item.id <= 0 || item.id == ''" type="primary"
                        @click="addCaseEvidenceInfo(item, 'eviForm', index)">新增抵押物信息</el-button>
                      <el-button v-else type="primary"
                        @click="updateCaseEvidenceInfo(item, 'eviForm', index)">更新抵押物信息</el-button>

                      <el-button type="danger" @click="deleteCaseEvidenceInfo(index)">删除抵押物</el-button>
                    </div>
                  </el-form>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-collapse-item>

          <!--分期信息-->
          <el-collapse-item name="6" v-show="this.caseInfo.cause == '信用卡纠纷'">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-shop"></i>
                分期信息
                <el-button size="mini" type="success" plain round style="margin: 10px 0" @click.stop="addInstallment()">
                  +添加分期信息
                </el-button>
                <a name="diyawu" id="diyawuId"></a>
              </div>
            </template>
            <el-collapse v-model="installNames" v-for="(installment, index) in caseInfo.czInstallment" :key="index">
              <el-collapse-item>
                <template slot="title">
                  <div class="itemName" style="display: flex">

                    分期信息: {{ installment.installmentType }}
                  </div>
                </template>
                <el-form :inline="true" ref="czInsForm" :model="installment" label-width="100px"
                  :rules="czInstallmentRules" class="demo-ruleForm">
                  <el-row>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="分期类型：" prop="installmentType">
                        <el-select @change="switchValid" clearable style="width: 100%"
                          v-model="installment.installmentType" placeholder="请选择分期类型"
                          @focus="changeDocName('分期类型', false)">
                          <el-option v-for="fenQiItem in fenQi" :label="fenQiItem.label" :value="fenQiItem.value"
                            :key="fenQiItem.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="信用卡号" prop="cardNumber">
                        <el-select @change="switchValid" clearable style="width: 100%"
                          @focus="changeDocName('分期信息信用卡号', false)" v-model="installment.cardNumber"
                          placeholder="请选择信用卡">
                          <el-option v-for="cardInfo in caseInfo.cardInfoList" :label="cardInfo.cardNumber"
                            :value="cardInfo.cardNumber" :key="cardInfo.cardNumber"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="分期协议名称：" prop="stagesScheme">
                        <el-select filterable style="width: 100%" v-model="installment.stagesScheme"
                          @focus="changeDocName('分期协议名称', true)" placeholder="">
                          <el-option v-for="item in stagesScheme" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="协议签署时间：" prop="agreementDate">
                        <el-date-picker style="width: 100%" v-model="installment.agreementDate" type="date"
                          @focus="changeDocName('协议签署时间', true)" value-format="yyyy-MM-dd" format="yyyyMMdd"
                          placeholder="选择日期时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="放款日期：" prop="loanDate">
                        <el-date-picker style="width: 100%" v-model="installment.loanDate" type="date"
                          @focus="changeDocName('放款日期', false)" value-format="yyyy-MM-dd" format="yyyyMMdd"
                          placeholder="选择日期时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="分期金额：" prop="borrowingSum">
                        <el-input @input="replaceObjectMoney($event, 'borrowingSum')" maxlength="9" style="width: 100%"
                          @focus="changeDocName('分期金额', false)" v-model="installment.borrowingSum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item label="分期总手续费：" prop="borrowingChargeSum">
                        <el-input @input="replaceObjectMoney($event, 'borrowingChargeSum')
                          " maxlength="9" style="width: 100%" @focus="changeDocName('分期总手续费', false)"
                          v-model="installment.borrowingChargeSum"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item prop="installmentSum" label="分期期数：">
                        <el-input @input="replaceObjectMoney($event, 'installmentSum')" maxlength="9"
                          style="width: 100%" v-model="installment.installmentSum"
                          @focus="changeDocName('分期期数', false)"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item prop="chargeRate" label="手续费率：">
                        <el-input style="width: 100%" @input="replaceObjectMoney($event, 'chargeRate')" maxlength="9"
                          @focus="changeDocName('手续费率', true)" v-model="installment.chargeRate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item prop="billDate" label="还款日：">
                        <el-input style="width: 100%" v-model="installment.billDate" maxlength="9"
                          @focus="changeDocName('还款日', false)"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="spanWidth" style="height: 60px">
                      <el-form-item prop="billMoney" label="还款金额：">
                        <el-input @input="replaceObjectMoney($event, 'billMoney')" maxlength="9"
                          @focus="changeDocName('还款金额', false)" v-model="installment.billMoney"
                          style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="spanWidth" style="height: 60px"> </el-col>
                  </el-row>
                  <el-row> </el-row>

                  <div></div>
                  <div style="width: 20rem; margin: 0 auto">


                    <el-button type="primary"
                      @click="updateCzInstallmentInfo('czInsForm', index, installment)">保存</el-button>

                    <el-button type="danger" @click="deleteCaseczInstallment(installment.id)">删除</el-button>
                  </div>
                </el-form>
              </el-collapse-item>
            </el-collapse>

          </el-collapse-item>


          <!--贷款合同要素-->
          <el-collapse-item name="7" v-show="this.caseInfo.cause == '金融借款合同纠纷'">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-claim"></i>
                金融借款合同要素
                <a name="daikuanyaosu" id="daikuanyaosuId"></a>
              </div>
            </template>
            <div style="margin-top: 50px" class="form-content">
              <el-form :inline="true" ref="czFinancialForm" :model="czFinancialContract" label-width="100px"
                :rules="czFinancialContractRules" class="demo-ruleForm">
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="合同签订日期：" prop="contractAwardDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.contractAwardDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="合同名称：" prop="contractName">
                      <el-select filterable style="width: 100%" v-model="czFinancialContract.contractName"
                        placeholder="">
                        <el-option v-for="item in loanContractName" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="contractNum" label="合同编号：">
                      <el-input v-model="czFinancialContract.contractNum" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="creditLine" label="授信额度：">
                      <el-input @input="replaceObjectMoney($event, 'creditLine')" maxlength="11"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.creditLine"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="rate" label="约定年利率：">
                      <el-input v-model="czFinancialContract.rate" type="number" style="width: 100%">
                        <template slot="append">%</template></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="借款期限起始日期：" prop="loanStartDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.loanStartDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="借款期限截至日期：" prop="loanEndDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.loanEndDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="loanTerm" label="单笔借款期限（月）：">
                      <el-input v-model="czFinancialContract.loanTerm" style="width: 100%"
                        oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="借款用途：" prop="loanPurpose">
                      <el-select filterable style="width: 100%" v-model="czFinancialContract.loanPurpose"
                        placeholder="">
                        <el-option v-for="item in purposes" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="还款方式：" prop="paymentMethod">
                      <el-select filterable style="width: 100%" v-model="czFinancialContract.paymentMethod">
                        <el-option v-for="item in paymentMethods" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="本金到期日期：" prop="principalDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.principalDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="逾期日期：" prop="overdueDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.overdueDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="利息截止日期：" prop="deadlineDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.deadlineDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="payPrincipal" label="已还本金：">
                      <el-input @input="replaceObjectMoney($event, 'payPrincipal')" maxlength="11"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.payPrincipal"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="payInterest" label="已还利息：">
                      <el-input @input="replaceObjectMoney($event, 'payInterest')" maxlength="11"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.payInterest"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="principal" label="总本金：">
                      <el-input @input="replaceObjectMoney($event, 'principal')" maxlength="11" :disabled="true"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.principal"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="interest" label="总利息：">
                      <el-input @input="replaceObjectMoney($event, 'interest')" maxlength="11" :disabled="true"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.interest"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div style="width: 20rem; margin: 0 auto">
                  <el-button type="primary" @click="updateFinancialContract('czFinancialForm')">保存</el-button>
                  <!-- <el-button type="danger" @click="deleteFinancialContract(czFinancialContract.id)">删除</el-button> -->
                </div>
              </el-form>
            </div>
          </el-collapse-item>

          <!--贷款使用详情-->
          <el-collapse-item name="8" v-show="this.caseInfo.cause == '金融借款合同纠纷'">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-finance"></i>
                贷款使用明细
                <el-button type="success" size="mini" plain round style="margin: 10px 0"
                  @click.stop="addczFinancialDetail()">
                  +添加贷款使用明细
                </el-button>
                <a name="daikuanxq" id="daikuanxqId"></a>
              </div>
            </template>
            <div class="form-content">
              <el-collapse v-model="openFinancialDetails" v-for="(item, index) in czFinancialDetails" :key="item.id">
                <el-collapse-item :name="item.id">
                  <template slot="title">
                    <div class="itemName" style="display: flex">
                      {{ "贷款合约号:" + item.contractCode }}
                      <el-upload style="margin-left: 20px" :action="getOcrloadUrl()" multiple
                        :http-request="HttpUploadFileByFD" :on-change="fileChange" :file-list="fileList">
                        <el-button size="small" @click="getFinancialDetailsIndex(index)"
                          type="primary">识别贷款基本信息</el-button>
                      </el-upload>
                    </div>
                  </template>
                  <div style="margin-top: 10px">
                    <el-form :inline="true" :rules="financialDetailRules" :model="item" label-width="100px"
                      ref="financialDetailForm" class="demo-ruleForm">
                      <el-row>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="开户行：" prop="bankName">
                            <el-input v-model="item.bankName" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="收款账号：" prop="bankCard">
                            <el-input v-model="item.bankCard" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="贷款合约号：" prop="contractCode">
                            <el-input v-model="item.contractCode" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="借款金额：" prop="amount">
                            <el-input maxlength="9" v-model="item.amount" oninput="value=value.replace(/[^\d.]/g,'')"
                              style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="borrowDate" label="借款日期：">
                            <el-date-picker placeholder="选择时间" v-model="item.borrowDate" style="width: 100%"
                              value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item prop="expiryDate" label="到期日期：">
                            <el-date-picker placeholder="选择时间" v-model="item.expiryDate" style="width: 100%"
                              value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="已还本金：" prop="payPrincipal">
                            <el-input maxlength="9" oninput="value=value.replace(/[^\d.]/g,'')"
                              @input="calPrincipalAndInterest(item)" v-model="item.payPrincipal" style="width: 100%"
                              prop="payPrincipal"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="已还利息：" prop="payInterest">
                            <el-input maxlength="9" oninput="value=value.replace(/[^\d.]/g,'')"
                              @input="calPrincipalAndInterest(item)" v-model="item.payInterest" style="width: 100%"
                              prop="payInterest"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="应还本金：" prop="principal">
                            <el-input maxlength="9" oninput="value=value.replace(/[^\d.]/g,'')"
                              @input="calPrincipalAndInterest(item)" v-model="item.principal" style="width: 100%"
                              prop="principal"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="应还利息：" prop="interest">
                            <el-input maxlength="9" oninput="value=value.replace(/[^\d.]/g,'')"
                              @input="calPrincipalAndInterest(item)" v-model="item.interest" style="width: 100%"
                              prop="interest"></el-input>
                          </el-form-item>
                        </el-col>
                        

                        <el-col :span="spanWidth" style="height: 60px">
                          <el-form-item label="应还本息：" prop="principalAndInterest">
                            <el-input maxlength="9" oninput="value=value.replace(/[^\d.]/g,'')" :disabled="true"
                              v-model="item.principalAndInterest" style="width: 100%"
                              prop="principalAndInterest"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <div style="width: 20rem; margin: 0 auto">
                        <el-button type="primary" v-if="item.id <= 0 || item.id == ''"
                          @click="addFinancialDetail(item, 'financialDetailForm', index)">新增</el-button>
                        <el-button type="primary" v-else
                          @click="updateFinancialDetail(item, 'financialDetailForm', index)">更新</el-button>
                        <el-button type="danger" @click="deleteFinancialDetail(item.id)">删除</el-button>
                      </div>
                    </el-form>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-collapse-item>

          <!--买卖合同要素-->
          <el-collapse-item name="7" v-show="this.caseInfo.cause == '买卖合同纠纷'">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-claim"></i>
                买卖合同要素
                <a name="daikuanyaosu" id="daikuanyaosuId"></a>
              </div>
            </template>
            <div style="margin-top: 50px" class="form-content">
              <el-form :inline="true" ref="czFinancialForm" :model="czFinancialContract" label-width="100px"
                :rules="czFinancialContractRules" class="demo-ruleForm">
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="合同签订日期：" prop="contractAwardDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.contractAwardDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="合同名称：" prop="contractName">
                      <el-select filterable style="width: 100%" v-model="czFinancialContract.contractName"
                        placeholder="">
                        <el-option v-for="item in loanContractName" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="contractNum" label="合同编号\用户pin：">
                      <el-input v-model="czFinancialContract.contractNum" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="creditLine" label="授信额度：">
                      <el-input @input="replaceObjectMoney($event, 'creditLine')" maxlength="11"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.creditLine"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="rate" label="约定年利率：">
                      <el-input v-model="czFinancialContract.rate" type="number" style="width: 100%">
                        <template slot="append">%</template></el-input>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <!-- <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="借款期限起始日期：" prop="loanStartDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.loanStartDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="借款期限截至日期：" prop="loanEndDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.loanEndDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row> -->

                <!-- <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="loanTerm" label="单笔借款期限（月）：">
                      <el-input v-model="czFinancialContract.loanTerm" style="width: 100%"
                        oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="借款用途：" prop="loanPurpose">
                      <el-select filterable style="width: 100%" v-model="czFinancialContract.loanPurpose"
                        placeholder="">
                        <el-option v-for="item in purposes" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->

                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="还款方式：" prop="paymentMethod">
                      <el-select filterable style="width: 100%" v-model="czFinancialContract.paymentMethod">
                        <el-option v-for="item in paymentMethods" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="逾期日期：" prop="overdueDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.overdueDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-row>
                  
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item label="本金到期日期：" prop="principalDate">
                      <el-date-picker style="width: 100%" v-model="czFinancialContract.principalDate" type="date"
                        value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <el-row>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="payPrincipal" label="已还本金：">
                      <el-input @input="replaceObjectMoney($event, 'payPrincipal')" maxlength="11"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.payPrincipal"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="spanWidth" style="height: 60px">
                    <el-form-item prop="principal" label="总本金：">
                      <el-input @input="replaceObjectMoney($event, 'principal')" maxlength="11" :disabled="true"
                        oninput="value=value.replace(/[^\d.]/g,'')" v-model="czFinancialContract.principal"
                        style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  
            
                </el-row>

                <div style="width: 20rem; margin: 0 auto">
                  <el-button type="primary" @click="updateFinancialContract('czFinancialForm')">保存</el-button>
                  <!-- <el-button type="danger" @click="deleteFinancialContract(czFinancialContract.id)">删除</el-button> -->
                </div>
              </el-form>
            </div>
          </el-collapse-item>


        </el-collapse>
      </div>
    </div>

    <div style="display: flex" class="sidebar2">
      <el-button size="mini" type="success" @click="lastCase()" style="margin-right: 15px">上一个案件</el-button>
      <div style="width: 128px" v-for="item in menu" :key="item.name">
        <div class="navigation" @click="clickSideBar(item)">
          {{ item.name }}
        </div>
      </div>
      <el-button size="mini" type="success" @click="nextCase()" style="margin-left: 15px">下一个案件</el-button>
    </div>

    <div></div>
  </div>
</template>

<script>

import {
  getCastAllInfo,
  updateCaseBaseInfo,
  updateCasePartyInfo,
  updateCaseAgentInfo,
  updateCaseCardInfo,
  updateCaseEvidenceInfo,
  updateCzInstallmentInfo,
  addCasePartyInfo,
  addAgentInfo,
  addCaseCardInfo,
  deleteCaseEvidenceInfo,
  deleteCaseAgentInfo,
  saveOfUpdatePartyInfo,
  addCaseEvidenceInfo,
  deleteCasePartyInfo,
  addCzInstallmentInfo,
  deleteCaseczInstallment,
  deleteCaseCardInfo,
  autoGenerDom,
  ocrReq,
  getBankInfoById,
  getPdfByCaseId,
  changeDocPage,
  changeIdCardPage,
  changeDocDate,
  goToPage
} from "@/api/czManager/register/index";
import { renderAsync } from "docx-preview";
import {
  identifyIdCard,
} from "@/api/czManager/liveCaseInfo/index";
//引入VueOfficeDocx组件
//引入相关样式
import { validatePhone, validateCardId } from "@/utils/myUtils/validate";
var validateId = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("身份证不能为空"));
  } else {
    callback();
  }
};
var validatePh = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else if (!validatePhone(value)) {
    callback("手机号格式不对");
  } else {
    callback();
  }
};
var validateCard = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("信用卡不能为空"));
  } else if (value.length < 16 || value.length > 16) {
    callback("信用卡位数不对");
  } else {
    callback();
  }
};

import {
  page,
  addCaseInfo,
  validateNull,
  selectConfigMap
} from "@/api/czManager/czCaseInfo/index";
import { addOrUpdateFinaContr, updateFinancialContract, deleteFinancialContract } from "@/api/czManager/czFinancialContract/index";
import { addOrUpdateFinaDetail, updateFinancialDetail, deleteFinancialDetail } from "@/api/czManager/czFinancialDetail/index";
import { ocrCard, ocrFinancialDetail } from "@/utils/ocrText.js";
import { guid } from "@/utils/index";
import util from "@/libs/util";
import axios from "axios";
import pdfpreview from "@/pages/caseMediate/pdfpreview";
export default {
  //import引入的组件需要注入到对象中才能使用

  components: {
    pdfpreview
  },

  props: ["id", "currentRow", "index", "page", "list", "limit", "mkey", 'plaintiffName'],
  data() {
    //这里存放数据
    return {
      wenshuSwtich: false,
      yuanCaiLiaoSwtich: false,
      ygId: '',
      yg: '',
      currentUserIndex: 0,
      idCardFileList: [],
      climit: 10,
      ckey: "",
      showDoc: false,
      cid: "",
      menu: [],
      openData: [],
      openProduct: [],
      openCard: [],
      openDiya: [],
      openFinancialDetails: [],
      textTip: "预览文书",
      spanWidth: 12,
      loanContractName: '',
      purposes: '',
      paymentMethods: '',
      applicationType: [],
      loading: false,
      editorOptions: {
        height: "60%",
      },
      docWidth: "0%",
      formWidth: "100%",
      docx: "",
      currentIndex: 0,
      textType: [
        "2025起诉状",
        "要素表",
        "证据材料清单",
        "财产保全申请书",
        "网络查控申请书",
        "担保函",
        "所函",
        "授权委托书",
      ],
      isLoad: false,
      fileList: [],
      fenQi: [],
      productNameList: [],
      czInsForm: {
        installmentType: "",
        stagesScheme: "",
        loanDate: "",
        borrowingSum: "",
        borrowingChargeSum: "",
        installmentSum: "",
        chargeRate: "",
        billDate: "",
        billMoney: "",
      },
      stagesScheme: [],
      areementList: [],
      defNames: [],
      plaNames: [],
      plaAgentNames: [],
      defAgentNames: [],
      cardNames: [],
      eviNames: [],
      activeNames: ["1"],
      active: 1,
      caseStatus: [],
      plaList: [],
      plaAgentList: [],
      defAgentList: [],

      defList: [],
      responsibility: ["连带清偿责任", "共同还款责任", "抵押责任", "担保责任",],
      defRelationship: ["夫妻关系", "亲属关系"],
      phoneFlag: false,
      idCardFlag: false,
      caseInfo: {
        cardInfoList: [
          {
            accountDestroyDate: "",
            accountDestroyEndDate: "",
            accountNumber: "",
            agreementInterest: "",
            applicationDate: "",
            cardNumber: "",
            caseId: 0,
            createTime: "",
            deadlineDate: "",
            editTime: "",
            founder: "",
            id: 0,
            interest: "",
            interestMethod: "",
            lawyerFees: "",
            liqDamagesEndDate: "",
            liquidatedDamages: "",
            operator: "",
            otherDescription: "",
            otherDescription2: "",
            otherDescription2EndDate: "",
            otherDescriptionEndDate: "",
            otherExpenses: "",
            otherExpenses2: "",
            overdueDate: "",
            principal: "",
            registerCode: "",
            serviceCharge: "",
            serviceChargeEndData: "",
            serviceChargeTwo: "",
            serviceChargeTwoEndDate: "",
            signingName: "",
            totalDebt: "",
          },
        ],
        czCaseAgentList: [
          {
            address: "",
            agentName: "",
            agentType: "",
            agentPosition: "",
            caseId: 0,
            createTime: "",
            founder: "",
            id: 0,
            idCard: "",
            isPresent: true,
            lawfirmName: "",
            lawyerLicenseNo: "",
            phone: "",
          },
        ],
        czEvidence: [
          {
            caseId: 0,
            createTime: "",
            editTime: "",
            evidenceName: "",
            evidenceNum: "",
            evidenceType: "",
            founder: "",
            id: "",
            operator: "",
            registrationDate: "",
          },
        ],
        czInstallment: {
          agreementDate: "",
          billDate: "",
          billMoney: "",
          borrowingChargeSum: "",
          borrowingSum: "",
          caseId: 0,
          chargeRate: "",
          createTime: "",
          editTime: "",
          founder: "",
          id: 0,
          installmentSum: "",
          installmentType: "",
          loanDate: "",
          operator: "",
          overdueDate: "",
          stagesScheme: "",
        }
      },
      czFinancialContract: {
        id: '',
        caseId: '',
        contractAwardDate: '',
        contractName: '',
        contractNum: '44020120',
        rate: '',
        creditLine: '',
        loanStartDate: '',
        loanEndDate: '',
        loanTerm: '',
        loanPurpose: '',
        paymentMethod: '',
        principalDate: '',
        overdueDate: '',
        principal: '',
        interest: '',
        payPrincipal: '',
        payInterest: '',
        deadlineDate: ''
      },
      czFinancialDetails: [],
      cause: "",
      eviRules: {
        registrationDate: [
          {
            required: true,
            message: "请选择抵押物登记日期",
            trigger: "change",
          },
        ],
        evidenceName: [
          {
            required: true,
            message: "请输入抵押物名称",
            trigger: "blur",
          },
        ],
        evidenceType: [
          {
            required: true,
            message: "请输入抵押物类型",
            trigger: "blur",
          },
        ],
        evidenceNum: [
          {
            required: true,
            message: "请选输入抵押物编号",
            trigger: "blur",
          },
        ],
      },
      baseRules: {
        courtSubDate: [
          {
            required: false,
            message: "请选择提交法院日期",
            trigger: "change",
          },
        ],
        batchId: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        courtName: [
          { required: true, message: "请选择法院", trigger: "change" },
        ],
        caseStatus: [
          { required: true, message: "请选择案件状态", trigger: "change" },
        ],
      },

      plaRules: {
        partiesType: [
          { required: true, message: "请选择案件类型", trigger: "change" },
        ],
        litigationStatus: [
          {
            required: true,
            message: "请选择诉讼地位",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: "blur",
          },
        ],
        serviceAddress: [
          { required: true, message: "请输入送达地址", trigger: "blur" },
        ],
        address: [
          {
            required: true,
            message: "请输入户籍地/公司所在地",
            trigger: "blur",
          },
        ],
        legalRepresentative: [
          {
            required: true,
            message: "请输入法定代表人",
            trigger: "blur",
          },
        ],
        post: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur",
          },
        ],
        legalRepresentativeIdCard: [
          {
            validator: validateId,
            required: true,
          },
        ],
      },
      czFinancialContractRules: {
        contractAwardDate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        contractName: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        rate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        contractNum: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        creditLine: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        loanStartDate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        loanEndDate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        loanTerm: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        loanPurpose: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        paymentMethod: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        principalDate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        overdueDate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        payPrincipal: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        payInterest: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        deadlineDate: [
          { required: true, message: "不能为空", trigger: "blur" },
        ]
      },
      financialDetailRules: {
        contractCode: [
          {
            required: true,
            message: '请输入贷款合约号',
            trigger: 'blur'
          }
        ], amount: [
          {
            required: true,
            message: '请输入借款金额',
            trigger: 'blur'
          }
        ], borrowDate: [
          {
            required: true,
            message: '请输入借款日期',
            trigger: 'blur'
          }
        ], expiryDate: [
          {
            required: true,
            message: '请输入到期日期',
            trigger: 'blur'
          }
        ], principal: [
          {
            required: true,
            message: '请输入本金余额',
            trigger: 'blur'
          }
        ], interest: [
          {
            required: true,
            message: '请输入应还利息',
            trigger: 'blur'
          }
        ], principalAndInterest: [
          {
            required: true,
            message: '请输入应还本息',
            trigger: 'blur'
          }
        ]
      },
      defRules: {
        responsibility: [
          { required: false, message: "请选择还款责任", trigger: "change" },
        ],
        defRelationship: [
          { required: false, message: "请选择被告关系", trigger: "change" },
        ],
        partiesType: [
          { required: true, message: "请选择案件类型", trigger: "change" },
        ],
        litigationStatus: [
          {
            required: true,
            message: "请选择诉讼地位",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur",
          },
        ],
        idCard: [{ required: true, validator: validateId }],

        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
        phone: [{ required: true, validator: validatePh }],
        serviceAddress: [
          { required: true, message: "请输入送达地址", trigger: "blur" },
        ],
        address: [
          {
            required: true,
            message: "请输入户籍地/公司所在地",
            trigger: "blur",
          },
        ],
      },

      defAgentRules: {
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        agentType: [
          {
            required: true,
            message: "请选择第一代理人类型",
            trigger: "change",
          },
        ],
        agentName: [
          {
            required: true,
            message: "请输入代理人名",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            validator: validateId,
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePh,
          },
        ],
        lawyerLicenseNo: [
          {
            required: true,
            message: "请输",

            trigger: "blur",
          },
        ],
        lawfirmName: [
          {
            required: true,
            message: "请输代理人所在律所名称",
            trigger: "blur",
          },
        ],
      },
      fileData: new FormData(),
      cardRules: {
        accountDestroyDate: [
          {
            required: false,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        accountDestroyEndDate: [
          {
            required: false,
            message: "请选择日期",
            trigger: "change",
          },
        ],

        productName: [
          {
            required: true,
            message: "请选择产品名称",
            trigger: "change",
          },
        ],
        overdueDate: {
          required: true,
          message: "请选择逾期日期",
          trigger: "change",
        },
        signingName: {
          required: true,
          message: "请选择签署协议名称",
          trigger: "change",
        },
        liquidatedDamages: [
          {
            required: false,
            message: "请输入违约金",
            trigger: "blur",
          },
        ],
        liqDamagesEndDate: [
          {
            required: false,
            message: "请选择违约金截止日期",
            trigger: "change",
          },
        ],
        interest: [
          {
            required: false,
            message: "请输入利息",
            trigger: "blur",
          },
        ],
        deadlineDate: [
          {
            required: false,
            message: "请选择利息截止日期",
            trigger: "change",
          },
        ],
        applicationDate: [
          {
            required: true,
            message: "请选择申请日期",
            trigger: "change",
          },
        ],
        applyTitle: [
          {
            required: true,
            message: "请选择申请表型",
            trigger: "change",
          },
        ],
        cardNumber: [
          {
            required: true,
            validator: validateCard,
          },
        ],
        principal: [
          {
            required: true,
            message: "请输入本金",
            trigger: "blur",
          },
        ],
        overdueDate: [
          {
            required: true,
            message: "请输入逾期日期",
            trigger: "change",
          },
        ],
        principalDate: [
          {
            required: false,
            message: "请输入本金截止日期",
            trigger: "change",
          },
        ],
        cutOffDate: [
          {
            required: false,
            message: "请输入流水截止日期",
            trigger: "change",
          },
        ],
        acceptingAuthority: [
          {
            required: true,
            message: "请输入受理机构",
            trigger: "change",
          }
        ],
        interestClause: [
          {
            required: true,
            message: "请输入条款",
            trigger: "change",
          }
        ],
        liquidatedDamagesClause: [
          {
            required: true,
            message: "请输入条款",
            trigger: "change",
          }
        ],
        breachLiability: [
          {
            required: false,
            message: "请输入条款",
            trigger: "change",
          }
        ]
      },
      czInstallmentRules: {
        installmentType: [
          {
            required: true,
            message: "请选择分期协议",
            trigger: "change",
          },
        ],
        stagesScheme: [
          {
            required: false,
            message: "请输入协议名称",
            trigger: "blur",
          },
        ],
        agreementDate: [
          {
            required: false,
            message: "请选择签署日期",
            trigger: "change",
          },
        ],
        loanDate: [
          {
            required: false,
            message: "请选择放款日期",
            trigger: "change",
          },
        ],
        borrowingSum: [
          {
            required: false,
            message: "请输入借款金额",
            trigger: "blur",
          },
        ],
        borrowingChargeSum: [
          {
            required: false,
            message: "请输入借款总手续费",
            trigger: "blur",
          },
        ],
        installmentSum: [
          {
            required: false,
            message: "请输入借款分期期数",
            trigger: "blur",
          },
        ],
        chargeRate: [
          {
            required: false,
            message: "请输入手续费率",
            trigger: "blur",
          },
        ],
        billDate: [
          {
            required: false,
            message: "请选择还款日期",
            trigger: "change",
          },
        ],
        billMoney: [
          {
            required: false,
            message: "请选择还款金额",
            trigger: "bulr",
          },
        ],
      },
      closeBtn: false,
      courtName: [],
      sex: "男",
      birthday: "",
      carIndex: "",
      cindex: 0,
      FdetailIndex: "",
      installNames: [],
      //原材料预览文档类型
      docName: '',
      pageTotalNum: 1,
      pageNum: 1,
      fileName: '',
      pdfUrl: '',
      fileOcrDetails: [],
      flipSwitch: true,
      //利息条款
      lxclauses: [],
      //违约金条款
      wyjclauses: [],
      //手续费条款
      sxfclauses: [],
      //违约责任条款
      breachLiability: [],
      //解除条件条款
      terminationConditions: [],
      //管辖条款
      agreedJurisdiction: []
    };
  },
  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化



  //方法集合
  methods: {
    switchOpen(val) {
      this.wenshuSwtich = val;
      if (val == true) {
        this.yuanCaiLiaoSwtich = !val;
      }
      if (val) {
        this.docWidth = "50%"
        this.formWidth = "50%"
        this.getDoc()
      } else {
        this.docWidth = "0%"
        this.formWidth = "100%"
      }
    },
    yuanCaiLiaoSwtichOpen(val) {
      this.yuanCaiLiaoSwtich = val;
      if (val == true) {
        this.wenshuSwtich = !val;
      }
      if (val) {
        this.docWidth = "50%"
        this.formWidth = "50%"
        this.getDoc()
      } else {
        this.docWidth = "0%"
        this.formWidth = "100%"
      }
    },


    changeYg(ygId, index, name) {
      this.plaList[index].name = name
      this.ygId = ygId
      getBankInfoById(ygId).then(res => {
        this.plaList[index].address = res.address
        this.plaList[index].serviceAddress = res.serviceAddress
        this.plaList[index].legalRepresentative = res.legalRepresentative
        this.plaList[index].phone = res.contact
        this.plaList[index].idCard = res.socialCreditCode
        this.plaList[index].post = res.post
        this.plaList[index].legalRepresentativeIdCard = res.legalRepresentativeIdCard

      })
    },
    ocrFileChange(file, fileList) {
      this.idCardFileList = fileList
    },
    ocrUploadFile(val) {
      this.fileData.append("file", val.file);
      const token = util.cookies.get("token");
      identifyIdCard(this.fileData, token).then((res) => {
        if (
          res.data.data == "" ||
          res.data.data == undefined ||
          res.data.data == null
        ) {
          this.$message.error("识别失败");
          return;
        }
        this.fileData = new FormData();
        this.$message.success("识别成功");

        let r = res.data.data
        let item = this.defList[this.currentUserIndex];
        r.birthday = r.birthday.length == 8 ? r.birthday.substring(0, 4) + '-'
          + r.birthday.substring(4, 6) + '-' + r.birthday.substring(6, 8) : '';
        item.name = r.name
        item.nation = r.nation
        item.sex = r.sex
        item.idCard = r.idCard
        item.birthday = r.birthday
        item.address = r.address
        item.serviceAddress = r.address
        item.partiesType = "自然人"
        item.litigationStatus = "被告"
        this.$set(this.defList, this.currentUserIndex, item)
      }).catch(err => {
        this.fileData = new FormData();
      });
    },
    getIdCardUploadUrl(index) {
      this.currentUserIndex = index
      return process.env.VUE_APP_API + "/api/case/liveCaseInfo/ocrIdCard";
    },

    nextCase() {
      //是否超过已有的内容

      if (this.cindex + 1 >= this.climit) {
        this.cpage++;
        this.cindex = 0;
        //获取分页数据
        if (this.ckey !== "" && this.ckey != undefined) {
          page({
            page: this.cpage,
            limit: this.climit,
            keyWord: this.ckey,
          }).then((res) => {
            this.clist = res.records;
            this.cid = this.clist[this.cindex].id;
            this.getCastAllInfo();
          });
        }
      } else {
        //能获取已有内容

        this.cid = this.clist[++this.cindex].id;
        this.getCastAllInfo();
      }
    },
    lastCase() {
      //超过已有的内容
      if (this.cindex - 1 < 0) {
        //不能分页
        if (this.cpage - 1 < 1) {
          return;
        } else {
          //可以分页
          this.cindex = 9;
          this.cpage--;
          if (this.ckey !== "" && this.ckey != undefined) {
            page({
              page: this.cpage,
              limit: this.climit,
              keyWord: this.ckey,
            }).then((res) => {
              this.clist = res.records;
              this.cid = this.clist[this.cindex].id;
              this.getCastAllInfo();
            });
          }
        }
      } else {
        this.cid = this.clist[--this.cindex].id;
        this.getCastAllInfo();
      }
    },
    clickSideBar(item) {
      const dom = document.getElementById(item.unid);
      switch (item.unid) {
        case "baseInfoId":
          this.openData.push("1");

          break;
        case "plaId":
          if (this.plaList.length > 0) {
            this.openData.push("2");
            for (let j = 0; j < this.plaList.length; j++) {
              if (this.plaNames.indexOf(this.plaList[j].id)) {
                this.plaNames.push(this.plaList[j].id);
              }
            }
          }
          break;
        case "defId":
          if (this.plaList.length > 0) {
            this.openData.push("2");

            for (let j = 0; j < this.defList.length; j++) {
              if (this.defNames.indexOf(this.defList[j].id)) {
                this.defNames.push(this.defList[j].id);
              }
            }
          }
          break;
        case "cardInfoId":
          if (this.caseInfo.cardInfoList.length > 0) {
            this.openData.push("4");
            for (let i = 0; i < this.caseInfo.cardInfoList.length; i++) {
              if (this.cardNames.indexOf(this.caseInfo.cardInfoList[i].id))
                this.cardNames.push(this.caseInfo.cardInfoList[i].id);
            }
          }
          break;
        case "diyawuId":
          if (this.caseInfo.czEvidence.length > 0) {
            this.openData.push("5");
            for (let i = 0; i < this.caseInfo.czEvidence.length; i++) {
              if (this.eviNames.indexOf(this.caseInfo.czEvidence[i].id))
                this.eviNames.push(this.caseInfo.czEvidence[i].id);
            }
          }

          break;
        case "fenqiId":
          if (
            this.caseInfo.czInstallment != undefined &&
            this.caseInfo.czInstallment.installmentType != "" &&
            this.caseInfo.czInstallment.installmentType != undefined
          ) {
            this.openData.push("6");
          }
          break;
        case "daikuanyaosuId":
          if (
            this.czFinancialContract != undefined &&
            this.czFinancialContract.contractName != "" &&
            this.czFinancialContract.contractName != undefined
          ) {
            this.openData.push("7");
          }
          break;
        case "daikuanxqId":
          if (
            this.CzFinancialDetail != undefined &&
            this.CzFinancialDetail.contractCode != "" &&
            this.CzFinancialDetail.contractCode != undefined
          ) {
            this.openData.push("8");
          }
          break;
      }
      dom.scrollIntoView({
        behavior: "smooth",
      });
    },
    getElementLeft(element) {
      var actualLeft = element.offsetTop;

      var current = element.offsetParent;
      while (current !== null) {
        actualLeft += current.offsetTop;
        current = current.offsetParent;
      }
      return actualLeft;
    },

    rendered() {
      this.loading = false;
    },
    switchLast() {
      if (this.currentIndex == 0) {
        this.currentIndex = this.textType.length - 1;
      } else {
        this.currentIndex -= 1;
      }
      this.getDoc();
    },
    switchNext() {
      this.currentIndex = (this.currentIndex + 1) % this.textType.length;
      this.getDoc();
    },

    //切换预览原材料的文档类型
    changeDocName(val, isBothContains) {
      if (this.flipSwitch) {
        var plaintiffName
        if (this.plaList.length > 0) {
          plaintiffName = this.plaList[0].name
        }

        if (plaintiffName.includes('中国银行') || plaintiffName.includes('中国农业银行')) {

          goToPage({ caseId: this.cid, fieldName: val, index: 0 }).then(res => {
            if (res != null) {
              if (this.pageNum != Number(res.page)) {
                this.pageNum = Number(res.page)
                this.pageTotalNum = Number(res.totalPage)
                this.di = Number(res.totalPage)
              }
            }
          })
        } else {
          changeDocPage(val, isBothContains, this)
        }
      }

    },

    //跳转身份证
    changeIdCard(index) {
      changeIdCardPage(index, this)
    },

    //跳转交易日期
    changeDocDatePage(dateType) {
      changeDocDate(dateType, this)
    },

    updatePageNum(newData) {
      this.pageNum = newData;
    },

    //获取PDF文档
    getDoc() {
      if (this.docWidth == '0%') {
        return
      }
      let loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.spanWidth = 12;
      var form = new FormData();
      form.append("caseIdList", [this.cid]);
      let data;
      var url;
      if (this.yuanCaiLiaoSwtich == true) {
        data = {
          caseId: this.cid,
          documentName: this.docName,
        };
        getPdfByCaseId(data).then(res => {
          this.fileOcrDetails = res.fileOcrDetails
          this.pageTotalNum = Number(res.pageTotalNum)
          this.pageNum = Number(res.pageNum)
          this.fileName = res.fileName
          var url = res.pdfUrl
          if (url.includes('http:')) {
            url = url.replace('http:', '')
          }
          this.pdfUrl = url
          this.showDoc = true;
        });
      } else if (this.wenshuSwtich == true) {
        validateNull(form).then((response) => {
          if (response.statusCode === 2000) {
            //预览文书参数与URL
            data = {
              caseId: this.cid,
              documentName: this.textType[this.currentIndex],
            };
            url = "/api/case/czCaseInfo/singleFile"
            this.showDoc = true;
            const token = util.cookies.get("token");
            axios({
              url: process.env.VUE_APP_API + url,
              method: "post",
              responseType: "arraybuffer",
              data: data,
              headers: {
                // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
                authorization: "Bearer " + token,
              },
            }).then((res) => {
              this.loading = true;
              const disposition = res.headers["content-disposition"];
              const fileName = decodeURI(disposition);
              const blob = new Blob([res.data]);
              let url = window.URL.createObjectURL(
                new File([res.data], { type: "application/msword" })
              );
              this.$message({
                message: this.textType[this.currentIndex],
                type: "success",
              });
              this.docx = url;
              let docxOptions = {
                inWrapper: false, // boolean：启用围绕文档内容的包装器渲染
                ignoreWidth: true, // boolean：禁用页面的渲染宽度
                ignoreHeight: true, // boolean：禁止渲染页面高度
                ignoreFonts: true, // boolean：禁用字体渲染
                breakPages: true, // boolean：在分页符上启用分页
                ignoreLastRenderedPageBreak: true, // boolean：在 lastRenderedPageBreak 元素上禁用分页
                experimental: false, // boolean：启用实验功能（制表符停止计算）
                trimXmlDeclaration: false, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
                useBase64URL: false,
                useMathMLPolyfill: false,
                showChanges: false,
                debug: false,
              };

              let childRef = document.getElementsByClassName("docxRef");
              renderAsync(blob, childRef[0], null, docxOptions);
            });
          } else {
            this.showDoc = false;
            this.$message({
              message: "无法获取文书内容：" + response.message,
            });
          }

        });
      }
      loading.close();
    },

    HttpUploadFileByCard(val) {
      this.fileData = new FormData();
      this.isLoad = true;
      this.fileData.append("field", val.file);
      const token = util.cookies.get("token");
      ocrReq(this.fileData, token).then((res) => {
        if (
          res.data.data == "" ||
          res.data.data == undefined ||
          res.data.data == null
        ) {
          this.$message.error("识别失败");
          return;
        }
        this.$message.success("识别成功");
        let card = ocrCard(res.data.data);

        let item = this.caseInfo.cardInfoList[this.carIndex]

        item.cardNumber = card.cardNumber
        item.principal = card.principal
        item.interest = card.interest
        item.serviceCharge = card.serviceCharge
        item.liquidatedDamages = card.liquidatedDamages
        item.accountNumber = card.accountNumber

        this.$set(this.caseInfo.cardInfoList, this.carIndex, item)
      });
      this.isLoad = false;
    },
    getIndex(index) {
      this.carIndex = index;
    },
    getFinancialDetailsIndex(index) {
      this.FdetailIndex = index
    },
    HttpUploadFileByFD(val) {
      this.isLoad = true;
      this.fileData.append("field", val.file);
      const token = util.cookies.get("token");
      ocrReq(this.fileData, token).then((res) => {
        if (
          res.data.data == "" ||
          res.data.data == undefined ||
          res.data.data == null
        ) {
          this.$message.error("识别失败");
          return;
        }
        this.fileData = new FormData();
        this.$message.success("识别成功");

        let detail = ocrFinancialDetail(res.data.data);
        Object.assign(this.czFinancialDetails[this.FdetailIndex], detail);
        this.calPrincipalAndInterest(this.czFinancialDetails[this.FdetailIndex])

      });
      this.isLoad = false;
    },
    getOcrloadUrl(index) {
      return process.env.VUE_APP_API + "/api/ocr/ocrRecord/identifyEveryFile";
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
      this.fileData.append("fields", file); // append增加数据
    },

    accountDateChange(val) {
      if (val != null && val != undefined && val != "") {
        this.cardRules["accountDestroyDate"][0].required = true;
        this.cardRules["accountDestroyEndDate"][0].required = true;
      } else {
        this.cardRules["accountDestroyDate"][0].required = false;
        this.cardRules["accountDestroyEndDate"][0].required = false;
      }
    },
    switchStatus(val) {
      if (val == "提交法院") {
        this.baseRules["courtSubDate"][0].required = true;
      }
    },
    getBirthdayAndSex(val, index) {
      if (val.length >= 14) {
        let temp = val.substring(6, 10);
        temp += "-" + val.substring(10, 12);
        temp += "-" + val.substring(12, 14);
        this.birthday = temp;
        this.defList[index].birthday = this.birthday;
      }
      if (val.length >= 17) {
        this.sex = val.substring(16, 17) % 2 == 1 ? "男" : "女";
        this.defList[index].sex = this.sex;
      }
    },

    switchValid(val) {
      if (val == "") {
        Object.keys(this.czInstallmentRules).forEach(
          (key) => (this.czInstallmentRules[key][0].required = false)
        );
        this.czInstallmentRules["installmentType"][0].required = true;
      } else if (val == "乐分易分期") {
        Object.keys(this.czInstallmentRules).forEach(
          (key) => (this.czInstallmentRules[key][0].required = false)
        );
        this.czInstallmentRules["installmentType"][0].required = true;
        this.czInstallmentRules["stagesScheme"][0].required = true;
        return;
      } else {
        for (let i = 0; i < this.plaList.length; i++) {
          if (this.plaList[i].name.indexOf("建设") != -1) {
            Object.keys(this.czInstallmentRules).forEach(
              (key) => (this.czInstallmentRules[key][0].required = false)
            );
            this.czInstallmentRules["installmentType"][0].required = true;
            this.czInstallmentRules["stagesScheme"][0].required = true;
            return;
          }
        }

        Object.keys(this.czInstallmentRules).forEach(
          (key) => (this.czInstallmentRules[key][0].required = true)
        );
      }
    },
    replaceMoney(value, name, index) {
      let val = "" + value;
      val =
        val
          .replace(/[^\d^\.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      this.caseInfo.cardInfoList[index][name] = val;
    },
    replaceObjectMoney(value, name) {
      let val = "" + value;
      val =
        val
          .replace(/[^\d^\.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      this.caseInfo.czInstallment[name] = val;
    },
    towNumber(val) {
      if (val.toFixed(2) < 0) {
        return 0;
      }
      return val.toFixed(2)
    },
    towNumber2(total, hexiao, lixi) {
      let a = hexiao - lixi;
      if (a.toFixed(2) < 0) {
        return total;
      }
      return (total - a).toFixed(2)
    },
    updateAgentInfo(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (this.idCardFlag || this.phoneFlag) return;
          updateCaseAgentInfo(item).then((response) => {
            if (response.statusCode == 2000) {
              this.$message({
                duration: 5000,
                message: "更新成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    deleteCaseEvidenceInfo(index) {
      this.$alert("确定要删除这部分抵押数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (this.caseInfo.czEvidence[index].id <= 0) {
              this.caseInfo.czEvidence.splice(index, 1);
              return;
            }
            deleteCaseEvidenceInfo(this.caseInfo.czEvidence[index].id).then(
              (response) => {
                if (response.statusCode == 2000) {
                  this.caseInfo.czEvidence.splice(index, 1);
                  this.$message({
                    duration: 5000,
                    message: "删除成功",
                    type: "info",
                  });
                  this.getCastAllInfo();
                } else {
                  this.$message({
                    duration: 5000,
                    message: response.message,
                    type: "error",
                  });
                }
              }
            );
          }
        },
      });
    },
    deleteCaseczInstallment(id) {
      this.$alert("确定要删除这部分数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (id > 0) {
              deleteCaseczInstallment(id).then((response) => {
                if (response.statusCode == 2000) {
                  this.$message({
                    duration: 5000,
                    message: "删除成功",
                    type: "info",
                  });
                  Object.keys(this.caseInfo.czInstallment).forEach(
                    (key) => (this.caseInfo.czInstallment[key] = "")
                  );
                  this.getCastAllInfo();
                } else {
                  this.$message({
                    duration: 5000,
                    message: response.message,
                    type: "error",
                  });
                }
              });
            } else {
              this.getCastAllInfo();
              this.$message({
                duration: 5000,
                message: "删除成功",
                type: "info",
              });
            }

          }
        },
      });
    },
    addEvidence(caseId) {
      this.caseInfo.czEvidence.push({
        id: guid() * -1,
        caseId,
      });

      this.eviNames.push(
        this.caseInfo.czEvidence[this.caseInfo.czEvidence.length - 1].id
      );
      if (this.openData.indexOf("5")) {
        this.openData.push("5");
      }
    },
    addInstallment() {
      this.caseInfo.czInstallment.push({
        id: guid() * -1,
        caseId: this.cid
      });


      this.installNames.push(
        this.caseInfo.czInstallment[this.caseInfo.czInstallment.length - 1].id
      );
      if (this.openData.indexOf("6")) {
        this.openData.push("6");
      }
    },
    addCaseEvidenceInfo(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          item.caseId = this.caseInfo.id;
          item.id = 0;
          addCaseEvidenceInfo(item).then((response) => {
            if (response.statusCode == 2000 || response.statusCode == 200) {
              this.$message({
                duration: 5000,
                message: "添加成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        }
      });
    },

    addCaseCardInfo(item, formName, index) {
      if (item.interest != "" && item.interest != null) {
        this.cardRules.deadlineDate[0].required = true;
      } else this.cardRules.deadlineDate[0].required = false;
      if (item.liquidatedDamages != "" && item.liquidatedDamages != null)
        this.cardRules.liqDamagesEndDate[0].required = false;
      else this.cardRules.liqDamagesEndDate[0].required = false;
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (item.id <= 0) item.id = 0;
          item.caseId = this.caseInfo.id;
          addCaseCardInfo(item).then((response) => {
            if (response.statusCode == 2000) {
              this.$message({
                duration: 5000,
                message: "添加成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        }
      });
    },

    addCard() {
      this.caseInfo.cardInfoList.push({
        accountDestroyDate: "",
        accountDestroyEndDate: "",
        accountNumber: "",
        agreementInterest: "",
        applicationDate: "",
        cardNumber: "",
        caseId: 0,
        createTime: "",
        deadlineDate: "",
        editTime: "",
        founder: "",
        id: guid() * -1,
        interest: "",
        interestMethod: "",
        lawyerFees: "",
        liqDamagesEndDate: "",
        liquidatedDamages: "",
        operator: "",
        otherDescription: "",
        otherDescription2: "",
        otherDescription2EndDate: "",
        otherDescriptionEndDate: "",
        otherExpenses: "",
        otherExpenses2: "",
        overdueDate: "",
        principal: "",
        registerCode: "",
        serviceCharge: "",
        serviceChargeEndData: "",
        serviceChargeTwo: "",
        serviceChargeTwoEndDate: "",
        signingName: "",
        totalDebt: "",
      });
      if (this.openData.indexOf("4")) {
        this.openData.push("4");
      }

      this.cardNames.push(
        this.caseInfo.cardInfoList[this.caseInfo.cardInfoList.length - 1].id
      );
    },
    addczFinancialDetail() {
      this.czFinancialDetails.push({
        id: guid() * -1,
        caseId: '',
        contractCode: "",
        amount: "",
        borrowDate: "",
        expiryDate: "",
        principal: "",
        interest: "",
        bankName: "",
        bankCard: "",
        principalAndInterest: undefined
      })

      this.openFinancialDetails.push(
        this.czFinancialDetails[this.czFinancialDetails.length - 1].id
      );

      if (this.openData.indexOf("8")) {
        this.openData.push("8");
      }
    },
    deleteCard(index) {
      this.$alert("确定要删除这张信用卡数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (this.caseInfo.cardInfoList[index].id <= 0) {
              this.caseInfo.cardInfoList.splice(index, 1);
              return;
            }
            deleteCaseCardInfo(this.caseInfo.cardInfoList[index].id).then(
              (response) => {
                if (response.statusCode == 2000) {
                  this.caseInfo.cardInfoList.splice(index, 1);
                  this.$message({
                    duration: 5000,
                    message: "删除成功",
                    type: "info",
                  });
                  this.getCastAllInfo();
                } else {
                  this.$message({
                    duration: 5000,
                    message: response.message,
                    type: "error",
                  });
                }

              }
            );
          }
        },
      });
    },
    addAgentInfo(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (this.idCardFlag || this.phoneFlag) return;
          if (item.id <= 0) item.id = "";
          addAgentInfo(item).then((response) => {
            if (response.statusCode == 2000) {
              this.$message({
                duration: 5000,
                message: "操作成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        } else {
        }
      });
    },
    addPlaAgent() {
      this.plaAgentList.push({
        sex: "男",
        address: "",
        agentName: "",
        agentType: "",
        caseId: this.caseInfo.id,
        createTime: "",
        founder: "",
        agentPosition: "原告",
        id: guid() * -1,
        idCard: "",
        isPresent: "",
        lawfirmName: "",
        lawyerLicenseNo: "",
        phone: "",
        legalRepresentativeIdCard: ""
      });
      this.plaAgentNames.push(
        this.plaAgentList[this.plaAgentList.length - 1].id
      );
      if (this.openData.indexOf("3")) {
        this.openData.push("3");
      }
    },
    deleteAgent(index, flag) {
      this.$alert("确定要删除这位代理人数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (flag == 1) {
              if (this.plaAgentList[index].id <= 0) {
                this.plaAgentList.splice(index, 1);
                return;
              }
              deleteCaseAgentInfo(this.plaAgentList[index].id).then(
                (response) => {
                  if (response.statusCode == 2000) {
                    this.plaAgentList.splice(index, 1);

                    this.$message({
                      duration: 5000,
                      message: "删除成功",
                      type: "info",
                    });
                    this.getCastAllInfo();
                  } else {
                    this.$message({
                      duration: 5000,
                      message: response.message,
                      type: "error",
                    });
                  }

                }
              );
            } else {
              if (this.defAgentList[index].id <= 0) {
                this.defAgentList.splice(index, 1);
                return;
              }
              deleteCaseAgentInfo(this.defAgentList[index].id).then(
                (response) => {
                  if (response.statusCode == 2000) {
                    this.defAgentList.splice(index, 1);
                    this.$message({
                      duration: 5000,
                      message: "删除成功",
                      type: "info",
                    });
                    this.getCastAllInfo();
                  } else {
                    this.$message({
                      duration: 5000,
                      message: response.message,
                      type: "error",
                    });
                  }

                }
              );
            }
          }
        },
      });
    },
    inputAddress(item, index) {
      item.serviceAddress = item.address
    },
    saveOfUpdatePartyInfo(item, formName, index) {
      this.defRules.defRelationship[0].required = false;
      this.defRules.responsibility[0].required = false;

      if (item.responsibility != null && item.responsibility != "") {
        this.defRules.defRelationship[0].required = true;
      }
      if (item.defRelationship != null && item.defRelationship != "") {
        this.defRules.responsibility[0].required = true;
      }

      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (item.id < 0) item.id = "";

          let str = item.nation;
          if (str != null && str != "") item.nation = str.replace(/族/g, "");

          saveOfUpdatePartyInfo(item).then((response) => {
            let str = response.message;
            if (response.statusCode == 2000) {
              this.$message({
                duration: 5000,
                message: "操作成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }

          });
        } else {
          document.querySelector(".bgIdCard").style.display = "none";
          document.querySelector(".bgPhone").style.display = "none";
          document.querySelector(".ygPhone").style.display = "none";
          document.querySelector(".ygIdCard").style.display = "none";
        }
      });
    },
    addCasePartyInfo(item, formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addCasePartyInfo(item).then((response) => {
            if (response.statusCode == 2000) {
              this.getCastAllInfo();
              this.$message("操作成功");
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    addDefendant(id) {
      this.defList.push({
        address: "",
        agentId: 0,
        agreedDeliveryAddress: "",
        birthday: "",
        caseId: id,
        createTime: "",
        defRelationship: "",
        editTime: "",
        email: "",
        founder: "",
        id: guid() * -1,
        idCard: "",
        legalRepresentative: "",
        litigationStatus: "被告",
        name: "",
        nation: "汉",
        operator: "",
        partiesType: "自然人",
        phone: "",
        post: "",
        responsibility: "",
        serviceAddress: "",
        sex: "",
        guaranteeContract: "",
        signingDate: ""
      });
      this.defNames.push(this.defList[this.defList.length - 1].id);
      if (this.openData.indexOf("2")) {
        this.openData.push("2");
      }
    },
    addPlaintiff(id) {
      this.plaList.push({
        address: "",
        agentId: 0,
        agreedDeliveryAddress: "",
        birthday: "",
        caseId: id,
        createTime: "",
        defRelationship: "",
        editTime: "",
        email: "",
        founder: "",
        id: guid() * -1,
        idCard: "",
        legalRepresentative: "",
        litigationStatus: "原告",
        name: "",
        nation: "",
        operator: "",
        partiesType: "企业",
        phone: "",
        post: "",
        responsibility: "",
        serviceAddress: "",
        sex: "",
        legalRepresentativeIdCard: ""
      });
      this.plaNames.push(this.plaList[this.plaList.length - 1].id);
      if (this.openData.indexOf("2")) {
        this.openData.push("2");
      }
    },
    deleteDefPartyInfo(index) {
      this.$alert("确定要删除当前被告数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (this.defList[index].id <= 0) {
              this.defList.splice(index, 1);
              return;
            }
            deleteCasePartyInfo(this.defList[index].id).then((response) => {
              if (response.statusCode == 2000) {
                this.defList.splice(index, 1);
                this.$message({
                  duration: 5000,
                  message: "删除成功",
                  type: "info",
                });
                this.getCastAllInfo();
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }

            });

          }
        },
      });
    },
    deletePlaPartyInfo(index) {
      this.$alert("确定要删除当前原告数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (this.plaList[index].id <= 0) {
              this.plaList.splice(index, 1);
              return;
            }
            deleteCasePartyInfo(this.plaList[index].id).then((response) => {
              if (response.statusCode == 2000) {
                this.plaList.splice(index, 1);
                this.$message({
                  duration: 5000,
                  message: "删除成功",
                  type: "info",
                });
                this.getCastAllInfo();
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }

            });

          }
        },
      });
    },
    getCastAllInfo() {

      getCastAllInfo({ caseId: this.cid }).then((response) => {
        if (response.cardInfoList.length == 0) {
          var cardInfoList = this.caseInfo.cardInfoList;
        }

        if (response.czCaseAgentList.length == 0) {
          var czCaseAgentList = this.caseInfo.czCaseAgentList;
        }
        if (response.czEvidence.length == 0) {
          var czEvidence = this.caseInfo.czEvidence;
        }
        if (response.czInstallment == undefined) {
          var czInstallment = this.caseInfo.czInstallment;
        }

        if (response.czFinancialContract != undefined) {
          this.czFinancialContract = response.czFinancialContract
        }
        if (response.czFinancialDetails != undefined) {
          this.czFinancialDetails = response.czFinancialDetails
        }

        if (response.cardInfoList == undefined) {
          var cardInfoList = {
            id: 0,
          };
        }

        this.getDoc();
        this.caseInfo = response;
        this.menuChange(response.cause)
        this.plaList = [];
        this.defList = [];
        this.plaAgentList = [];
        this.defAgentList = [];
        this.plaNames = [];
        this.defNames = [];
        for (let i = 0; i < this.caseInfo.partyList.length; i++) {
          if (this.caseInfo.partyList[i].litigationStatus == "原告") {
            this.plaList.push(this.caseInfo.partyList[i]);
          } else {
            this.defList.push(this.caseInfo.partyList[i]);
          }
        }
        for (let i = 0; i < this.caseInfo.czCaseAgentList.length; i++) {
          if (this.caseInfo.czCaseAgentList[i].agentPosition == "原告") {
            this.plaAgentList.push(this.caseInfo.czCaseAgentList[i]);
          } else {
            this.defAgentList.push(this.caseInfo.czCaseAgentList[i]);
          }
        }
        this.caseInfo.czCaseAgentList =
          czCaseAgentList == undefined
            ? this.caseInfo.czCaseAgentList
            : czCaseAgentList;
        this.caseInfo.czInstallment = czInstallment == undefined
          ? this.caseInfo.czInstallment
          : czInstallment;
        if (this.caseInfo) {
          this.openData.push("1");
        }
        if (this.defList.length > 0) {
          this.openData.push("2");

          for (let j = 0; j < this.defList.length; j++) {
            this.defNames.push(this.defList[j].id);
          }
        }
        // if (
        //   this.caseInfo.czInstallment != undefined &&
        //   this.caseInfo.czInstallment.installmentType != "" &&
        //   this.caseInfo.czInstallment.installmentType != undefined
        // ) {
        //   this.openData.push("6");
        // }

        if (this.caseInfo.czInstallment.length > 0) {
          this.openData.push("6");
          for (let i = 0; i < this.caseInfo.czInstallment.length; i++) {
            this.installNames.push(this.caseInfo.czInstallment[i].id);
          }
        }
        if (this.caseInfo.czEvidence.length > 0) {
          this.openData.push("5");
          for (let i = 0; i < this.caseInfo.czEvidence.length; i++) {
            this.eviNames.push(this.caseInfo.czEvidence[i].id);
          }
        }

        if (this.caseInfo.cardInfoList.length > 0) {
          this.openData.push("4");
          for (let i = 0; i < this.caseInfo.cardInfoList.length; i++) {
            this.cardNames.push(this.caseInfo.cardInfoList[i].id);
          }
        }
        if (this.czFinancialContract.contractName != "") {
          this.openData.push("7");
        }
        if (this.czFinancialDetails.length > 0) {
          this.openData.push("8");
        }
      });
    },
    submitBaseForm(formName) {
      if (this.caseInfo.caseStatus == "提交法院") {
        this.baseRules["courtSubDate"][0].required = true;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const caseBaseInfo = {
            batchId: this.caseInfo.batchId || "",
            registerCode: this.caseInfo.registerCode || "",
            caseStatus: this.caseInfo.caseStatus || "",
            cause: this.caseInfo.cause || "",
            claim: this.caseInfo.claim || "",
            courtName: this.caseInfo.courtName || "",
            courtSubDate: this.caseInfo.courtSubDate || "",
            editTime: this.caseInfo.editTime || "",
            entrustmentDate: this.caseInfo.entrustmentDate || "",
            executionDate: this.caseInfo.executionDate || "",
            filingDate: this.caseInfo.filingDate || "",
            id: this.caseInfo.id || "",
            isRepayment: this.caseInfo.isRepayment || "",
            mediationDate: this.caseInfo.mediationDate || "",
            remark: this.caseInfo.remark || "",
            rulingDate: this.caseInfo.rulingDate || "",
            trialDate: this.caseInfo.trialDate || "",
            truth: this.caseInfo.truth || "",
            underlyingAmount: this.caseInfo.underlyingAmount || "",
            lawyerFee: this.caseInfo.lawyerFee || "",
            caseFilingFee: this.caseInfo.caseFilingFee || "",
            firstCollectionDate: this.caseInfo.firstCollectionDate || "",
            lastCollectionDate: this.caseInfo.lastCollectionDate || "",
            propertyPreservationFee: this.caseInfo.propertyPreservationFee || "",
            announcementFee: this.caseInfo.announcementFee || "",
            agreedJurisdiction: this.caseInfo.agreedJurisdiction || ""

          };
          updateCaseBaseInfo(this.caseInfo.id, caseBaseInfo).then(
            (response) => {
              if (response.statusCode == 2000) {
                this.$emit("getCaseStatus", this.caseInfo.caseStatus);
                this.$message({
                  duration: 5000,
                  message: "更新成功",
                  type: "success",
                });
                this.getCastAllInfo();
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    updateCaseCardInfo(item, formName, index) {
      if (item.interest != "" && item.interest != null) {
        this.cardRules.deadlineDate[0].required = true;
      } else this.cardRules.deadlineDate[0].required = false;
      if (item.liquidatedDamages != "" && item.liquidatedDamages != null)
        this.cardRules.liqDamagesEndDate[0].required = false;
      else this.cardRules.liqDamagesEndDate[0].required = false;
      this.$refs[formName][index].validate((valid) => {
        for (let key in this.caseInfo.cardInfoList[index]) {
          if (this.caseInfo.cardInfoList[index][key] == null) {
            this.caseInfo.cardInfoList[index][key] = "";
          }
        }

        if (valid) {
          updateCaseCardInfo(item).then((response) => {
            if (response.statusCode == 2000) {
              this.$message({
                duration: 5000,
                message: "更新成功",
                type: "success",
              });

              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    updateCaseEvidenceInfo(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          updateCaseEvidenceInfo(item).then((response) => {
            if (response.statusCode == 2000) {
              this.$message({
                duration: 5000,
                message: "更新成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    updateCzInstallmentInfo(formName, index, installment) {
      if (
        installment.installmentType == "汽车分期" ||
        installment.installmentType == "家装分期"
      ) {
        Object.keys(this.czInstallmentRules).forEach(
          (key) => (this.czInstallmentRules[key][0].required = true)
        );
      } else if (installment.installmentType == "乐分易分期") {
        Object.keys(this.czInstallmentRules).forEach(
          (key) => (this.czInstallmentRules[key][0].required = false)
        );
        this.czInstallmentRules["installmentType"][0].required = true;
        this.czInstallmentRules["stagesScheme"][0].required = true;
      } else {

      }
      for (let i = 0; i < this.plaList.length; i++) {
        if (this.plaList[i].name.indexOf("建设") != -1) {
          Object.keys(this.czInstallmentRules).forEach(
            (key) => (this.czInstallmentRules[key][0].required = false)
          );
          this.czInstallmentRules["installmentType"][0].required = true;
          this.czInstallmentRules["stagesScheme"][0].required = true;
        }
      }


      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (
            installment.id < 0 ||
            installment.id == ""
          ) {
            this.caseInfo.czInstallment.caseId = this.caseInfo.id;
            installment.id = null
            addCzInstallmentInfo(installment).then(
              (response) => {
                if (response.statusCode == 2000) {
                  this.$message({
                    duration: 5000,
                    message: "新增成功",
                    type: "success",
                  });
                  this.getCastAllInfo();
                } else {
                  this.$message({
                    duration: 5000,
                    message: response.message,
                    type: "error",
                  });
                }
              }
            );
          } else {
            updateCzInstallmentInfo(installment).then(
              (response) => {
                if (response.statusCode == 2000 || response.statusCode == 200) {
                  this.$message({
                    duration: 5000,
                    message: "更新成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    duration: 5000,
                    message: response.message,
                    type: "error",
                  });
                }
              }
            );
          }
        } else {
        }
      });
    },

    /**
     * 保存金融接口合同要素
     */
    updateFinancialContract(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.czFinancialContract.caseId = this.caseInfo.id
          if (this.czFinancialContract.id == undefined || this.czFinancialContract.id == '') {
            addOrUpdateFinaContr(this.czFinancialContract).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              }
              this.getCastAllInfo();
            })
          } else {
            updateFinancialContract(this.czFinancialContract).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              }
            })
          }


        }
      });
    },

    /**
   * 删除金融接口合同要素
   */
    deleteFinancialContract(id) {
      this.$alert("是否确认删除", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            deleteFinancialContract(id).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.czFinancialContract = {
                  id: '',
                  caseId: this.caseInfo.id,
                  contractAwardDate: '',
                  contractName: '',
                  contractNum: '44020120',
                  creditLine: '',
                  loanStartDate: '',
                  loanEndDate: '',
                  loanTerm: '',
                  loanPurpose: '',
                  paymentMethod: '',
                  principalDate: '',
                  overdueDate: '',
                  principal: '',
                  interest: '',
                  deadlineDate: ''
                },
                  this.getCastAllInfo();
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            });

          }
        },
      });

    },


    /**
     * 添加金融借款明细
     */
    addFinancialDetail(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          item.caseId = this.caseInfo.id;
          if (item.id < 0) {
            item.id = "";
          }
          addOrUpdateFinaDetail(item).then((response) => {
            if (response.statusCode == 2000 || response.statusCode == 200) {
              this.$message({
                duration: 5000,
                message: "添加成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
              this.czFinancialDet
            }
          });

        }
      });
    },

    /**
     * 更新  
     */
    updateFinancialDetail(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {

          updateFinancialDetail(item).then((response) => {
            if (response.statusCode == 2000 || response.statusCode == 200) {
              this.$message({
                duration: 5000,
                message: "添加成功",
                type: "success",
              });
              this.getCastAllInfo();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
          this.$message({
            duration: 5000,
            message: "更新成功",
            type: "info",
          });
        }
      });
    },

    /**
     * 删除金融借款明细
     */
    deleteFinancialDetail(id) {
      this.$alert("是否确认删除", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (id < 0) {
              this.getCastAllInfo();
              return;
            }
            deleteFinancialDetail(id).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });

                this.getCastAllInfo();
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            });

          }
        },
      });
    },

    calPrincipalAndInterest(item) {
      item.principalAndInterest = parseFloat((Number(item.principal) + Number(item.interest))).toFixed(2);


    },

    menuChange(cause) {
      if (cause == '信用卡纠纷') {
        this.menu = [
          {
            name: "案件基本信息",
            unid: "baseInfoId",
            id: "#baseInfo",
          },
          {
            name: "原告",
            id: "#pla",
            unid: "plaId",
          },
          {
            name: "被告",
            id: "#def",
            unid: "defId",
          },
          {
            name: "信用卡信息",
            id: "#cardInfo",
            unid: "cardInfoId",
          },
          {
            name: "抵押物信息",
            id: "#diyawu",
            unid: "diyawuId",
          },
          {
            name: "分期信息",
            id: "#fenqi",
            unid: "fenqiId",
          },
        ]
      } else {
        this.menu = [
          {
            name: "案件基本信息",
            unid: "baseInfoId",
            id: "#baseInfo",
          },
          {
            name: "原告",
            id: "#pla",
            unid: "plaId",
          },
          {
            name: "被告",
            id: "#def",
            unid: "defId",
          },

          {
            name: "金融借款合同要素",
            id: "#daikuanyaosu",
            unid: "daikuanyaosuId",
          },
          {
            name: "贷款使用明细",
            id: "#daikuanxq",
            unid: "daikuanxqId",
          },
        ]
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

    this.cid = this.id;
    this.cindex = this.index;
    this.cpage = this.page;
    this.clist = this.list;
    this.ckey = this.mkey;
    this.climit = this.limit;
    this.head = {
      authorization: "Bearer " + util.cookies.get("token"),
    };

    this.getCastAllInfo();
    selectConfigMap('loanContractName').then((res) => {
      this.loanContractName = res
    });
    selectConfigMap('purposes').then((res) => {
      this.purposes = res
    });
    selectConfigMap('paymentMethods').then((res) => {
      this.paymentMethods = res
    });
    selectConfigMap('lxclauses').then((res) => {
      this.lxclauses = res
    });
    selectConfigMap('wyjclauses').then((res) => {
      this.wyjclauses = res
    });
    selectConfigMap('sxfclauses').then((res) => {
      this.sxfclauses = res
    });
    selectConfigMap('breachLiability').then((res) => {
      this.breachLiability = res
    });
    selectConfigMap('terminationConditions').then((res) => {
      this.terminationConditions = res
    });
    selectConfigMap('agreedJurisdiction').then((res) => {
      this.agreedJurisdiction = res
    });

    this.productNameList = this.$store.state.d2admin.data.productName;
    this.stagesScheme = this.$store.state.d2admin.data.stagesScheme;
    this.courtName = this.$store.state.d2admin.data.courtList;
    this.caseStatus = this.$store.state.d2admin.data.caseStatus;
    this.areementList = this.$store.state.d2admin.data.areementList;
    this.fenQi = this.$store.state.d2admin.data.fenQi;
    this.applicationType = this.$store.state.d2admin.data.applicationType;

  },
  mounted() {
  }
};
</script>
<style scoped>
.formClass>>>.el-form-item {
  width: 100% !important;
}

.formClass>>>.el-form-item__label {
  width: 40% !important;
}

.formClass>>>.el-form-item__content {
  width: 60% !important;
}

.regBody>>>.el-dialog {
  margin-top: 0px !important;
  background-color: red !important;
}

.el-select .el-input {
  width: 330px;
}

.el-collapse-item:last-child {
  margin-bottom: 0px;
}

#body>>>.el-collapse {
  border: none;
}

#body .el-collapse .el-collapse-item>>>.el-collapse-item__header {
  height: 58px !important;
}

#body>>>.el-collapse-item__header {
  border: none;
}

#body>>>.is-process {
  color: #c0c4cc;
}

#body>>>.is-process>.el-step__icon {
  border: 2px solid #c0c4cc;
}

.caseInfoItemHead {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  background: #409eff;
  color: #fff;
}

.itemHead {
  width: 98.5%;
  margin-top: 20px;
  padding: 10px;
  background: linear-gradient(to left top, white, skyblue);
}

.itemName {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1.5em;
  background: #f2f1f7;
  justify-content: center;
}

.regBody>>>.el-upload-list__item {
  display: none !important;
}

.ar {
  position: absolute;
  top: 20%;
  right: 15px;
  z-index: 1000;
  border-radius: 14px;
  animation: arrowloadRight 2s infinite;
}

.lr {
  position: absolute;
  left: 0;
  top: 20%;
  /* bottom: 14px; */
  z-index: 1000;
  border-radius: 14px;
  animation: arrowload 2s infinite;
}

@keyframes arrowload {
  0% {
    opacity: 0;
    transform: translate(30px);
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(0px);
  }
}

@keyframes arrowloadRight {
  0% {
    opacity: 0;
    transform: translate(-30px);
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(0px);
  }
}

.lr:nth-child(1) {
  animation-delay: -0.4s;
}

.lr:nth-child(2) {
  animation-delay: -0.2s;
}

.ar:nth-child(1) {
  animation-delay: -0.4s;
}

.ar:nth-child(2) {
  animation-delay: -0.2s;
}


.regBody>>>.docx {
  margin: 0 auto !important;
}

li {
  line-height: 40px;
  text-align: center;
  list-style: none;
}

.sidebar:not(:last-child) {
  border-bottom: #f5f5f5 solid 1px;
}

li:hover {
  color: #fff;
  background-color: #ff8000;
}

.sidebar {
  position: fixed;
  top: 50%;
  right: 50px;
  /* left: 50%; */
  width: 128px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  padding: 0;
  transform: translateY(-50%);
  /* box-shadow: 3px 3px 0px rgba(0, 0, 0, 0.05); */
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.05),
    0px 3px 5px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px -1px rgba(0, 0, 0, 0.04);
}

a {
  display: block;
  width: 100%;
  height: 100%;
  color: #333;
  text-decoration: none;
}

.nextCase {
  position: absolute;
  right: 10px;
  top: 50%;
  z-index: 100;
  display: flex;

  flex-direction: column;
}

.sidebar2 {
  justify-content: center;
  position: fixed;
  bottom: 10px;
  width: 80vw;
  /* height: 27[]; */
  margin: 0 10vw;
  /* justify-content: space-between; */
}

.sidebar2 div {
  /* border-radius: 14px; */
  width: 128px;
  text-align: center;
  background-color: white;
  /* box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.05),
    0px 3px 5px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px -1px rgba(0, 0, 0, 0.04); */
  /* box-shadow: 7px 5px 4px rgba(0, 0, 0, 0.4); */
  box-shadow: 7px 5px 4px rgba(0, 0, 0, 0.4),
    -3px -2px 4px 0px rgba(0, 0, 0, 0.4);
}

.navigation {
  padding: 4px;
  /* border-radius: 14px; */
  /* box-shadow: 7px 5px 4px rgba(0, 0, 0, 0.4),
              -5px -20px 30px 0px rgba(0, 0, 0, 0.4); */
  bottom: 10px;
}

.navigation:hover {
  background-color: #ff8000;
  cursor: pointer;
}

.sperater {
  background-color: #409eff;
  height: 90%;
  width: 11px;
  position: absolute;
  top: 8%;
  right: 50%;
}

.docxRefPar .el-backtop {
  right: 50% !important;
}

.ygClass>>>.el-collapse-item {
  margin-top: 20px
}

.ygClass>>>.el-collapse-item__wrap {
  margin-top: 50px
}

.docxRefPar {
  width: 45%
}
</style>
